﻿export const lng: object = {
  phGlobal_OpenTime: "Öffnungszeiten",
  phGlobal_Pickup_openTime: "Abholzeiten",
  phGlobal_Delivery_openTime: "Lieferzeiten",
  phGlobal_InHouse_openTime: "Bestellzeiten",
  phGlobal_Return: "Zurück",
  phGlobal_Continue: "Weiter",
  phGlobal_Sum: "Summe",
  phGlobal_Discount: "Rabatt",
  phGlobal_Total: "Total",
  phGlobal_Deposit: "Pfand",
  phGlobal_DeliveryFee: "Liefergebühr",

  phGender_None: " ",
  phGender_Woman: "Weiblich",
  phGender_Man: "Männlich",
  phGender_Divers: "Divers",

  phPrefix_Man: "Herr",
  phPrefix_Woman: "Frau",
  phPrefix_Divers: "Divers",

  phOfflineIndicator_NoConnection: "Keine Verbindung",
  phOfflineIndicator_BackOnline: "Wieder Online",

  phUser_Credit: "Guthaben",
  phUser_Discount: "Rabatt",
  phUser_InvitationAmount: "Einladungsbetrag",

  phEmptyTab_Title: "Entschuldigung!",
  phEmptyTab_Content: "Hier gibt es zur Zeit leider nichts zu sehen. Bitte schaue bald wieder vorbei.",

  phEmptyTab_Tickets_Title: "Entschuldigung!",
  phEmptyTab_Tickets_Info: "Für diesen Tag sind aktuell keine Tickets verfügbar",

  phEmptyPage_Title: "Entschuldigung",
  phEmptyPage_Message: "Hier gibt es zur Zeit leider nichts zu sehen. Schaue bald wieder vorbei und kontrolliere bitte Deine Filtereinstellungen, damit Du alle für Dich interessanten Inhalte angezeigt bekommst.",

  phEmpty_UserLike_Page_Title: "Noch keine Likes?",
  phEmpty_UserLike_Page_Content: "Hier findest Du alle Inhalte, welche Du in der App mit einem 'Like' (Herz) gekennzeichnet hast, so dass Du sie jederzeit schnell wiederfindest. Probiere es gleich aus!",

  phErrorMessage_Title: "Entschuldigung...",
  phErrorMessage_Text: "Leider konnten wir Deine Anfrage nicht verarbeiten.<br>Bitte versuche es später erneut.",
  phErrorMessage_Text_Checkout: "Der Bestellvorgang konnte nicht durchgeführt werden.<br>Bitte versuche es zu einem späteren Zeitpunkt noch einmal.",
  phErrorMessage_Text_ResetBasket: "Bei der Verarbeitung des Warenkorbes ist leider ein technisches Problem aufgetreten.<br>Wir haben den Fehler bereits korrigiert und bitten Dich, die Bestellung erneut aufzugeben.<br>Vielen Dank für Dein Verständnis.",
  phErrorMessage_Button: "Ok",
  phErrorMessage_Title_MultipleOrder: "Hinweis",
  phErrorMessage_Text_MultipleOrder: "Deine Bestellung wurde bereits erfolgreich verarbeitet. Bitte überprüfe deine Mails",

  phDeliverAddressNotDestination_Title: "Entschuldigung...",
  phDeliverAddressNotDestination_Zip_Text: "Die Postleitzahl stimmt nicht mit der zuvor gewählten Lieferadresse \"{zip}\" überein.",
  phDeliverAddressNotDestination_ZipAndCity_Text: "Die Adresse stimmt nicht mit der zuvor gewählten Lieferadresse \"{zip}, {city}\" überein.",

  phLogin_Title: "Anmeldung",
  phLogin_PlaceholderEMail: "E-Mail",
  phLogin_PlaceholderPassword: "Passwort",
  phLogin_ForgotPassword: "Passwort vergessen?",
  phLogin_LogIn: "Login",
  phLogin_NotAMember: "Noch nicht registriert?",
  phLogin_Message: "Bitte prüfe Deine Eingaben:",
  phLogin_MessageErrorLogin_UnknownReason: "Der Login konnte leider nicht durchführt werden, bitte probiere es später noch einmal.",
  phLogin_MessageErrorLogin_NoEmailGiven: "Bitte gib Deine E-Mail ein.",
  phLogin_MessageErrorLogin_NoPasswordGiven: "Bitte gib Dein Passwort ein.",
  phLogin_MessageErrorAuth_InvalidEmail: "Die E-Mail ist ungültig.",
  phLogin_MessageErrorAuth_UserDisabled: "Eine Anmeldung ist zur Zeit nicht möglich.",
  phLogin_MessageErrorAuth_UserNotFound: "Die Zugangsdaten sind uns leider nicht bekannt.",
  phLogin_MessageErrorAuth_WrongPassword: "Die Zugangsdaten sind uns leider nicht bekannt.",
  phLogin_PasswordResetEmailSend: "Wir haben Dir eine E-Mail zum Zurücksetzen Deines Passwortes an <email> geschickt.",

  phMainNav_SideMenuHeader: "Menü",
  phMainNav_AboutUs: "Über uns",
  phMainNav_More: "Mehr",
  phMainNav_Home: "Start",
  phMainNav_Paymentoptions: "Zahlungsarten",
  phMainNav_Service: "Service",
  phMainNav_Legal: "Rechtliches",
  phMainNav_Language: "Sprache",
  phMainNav_Community: "Community",
  phMainNav_CopyRight: "Alle Rechte vorbehalten",

  phRatingDialog_SendRate: "Absenden",
  phRatingDialog_Characters_Available: "Verbleibende Zeichen",
  phRatingDialog_Validation_Message: "Du musst zuerst die Sterne überprüfen",

  phFilterLayer_Title: "Standort auswählen",
  phFilterLayer_Description: "Filtere weitere Standorte, um Dir vorübergehend zusätzliche Informationen anzeigen zu lassen. Unter Standorte kannst Du diese dauerhaft \"liken\".",
  phFilterLayer_Filter: "Filtern",

  phLoginDialog_Login: "Anmelden",
  phLoginDialog_Register: "Jetzt registrieren",

  phLanguageDialog_Title: "Sprache wählen",
  phLanguageDialog_lang_de: "Deutsch",
  phLanguageDialog_lang_en: "Englisch",

  phLocation_TabName_LocationList: "Liste",
  phLocation_TabName_Map: "Karte",
  phLocation_Search_Location: "Standort suchen",

  phLocationDetail_Route: "Dein Weg zu uns",
  phLocationDetail_Reservation: "Reservierung",
  phLocationDetail_Info_Title: "Adresse und Kontakt",
  phLocationDetail_TabName_Overview: "Übersicht",
  phLocationDetail_TabName_Order: "Bestellung",
  phLocationDetail_PlsChooseService_TEXT: "Bitte wähle aus, wie Du bei uns bestellen möchtest.",
  phLocationDetail_DeviatingOpeningHours: "Abweichende Öffnungszeiten",

  phEvent_TabName_Upcomming: "Aktuell",
  phEvent_TabName_Expired: "Vergangen",

  phEventDetail_Date: "Datum: ",
  phEventDetail_Time: "Uhrzeit: ",
  phEventDetail_From: "Von: ",
  phEventDetail_To: "Bis: ",
  phEventDetail_Location: "Teilnehmende Standorte:",

  phSnackBarMessages: {
    successfullyExecuted: "Erfolgreich ausgeführt",
    unkownLocation: "Standort kann nicht ermittelt werden",
    failed: "Fehlgeschlagen",
    locationNotFound: "Keine Standorte gefunden",
    UpdateFailed: "Aktualisierung fehlgeschlagen",
    deviceOffline: "Dein Gerät ist offline!",
    deviceOnline: "Dein Gerät ist online!",
    unsupported: "Dein Gerät wird nicht unterstützt!",
    scanAgain: "Erneut scannen",
    copiedToClipboard: "In die Zwischenablage kopiert",
    userJoinedTheGroup: "{userName} ist der Gruppe beigetreten",
    userLeftTheGroup: "{userName} hat die Gruppe verlassen",
    allMembersAreReady: "Alle Mitglieder sind bereit",
    accountPaymentSuccess: "Anfrage gesendet",
    accountPaymentError: "Anfrage konnte nicht gesendet werden",
    retailDeliveryCountryMissing: "Bitte wähle ein gültiges Lieferland aus, damit wir die Versandkosten berechnen können.",
  },

  phCounter_UnitNames: {
    Days: "Tage",
    Hours: "Stunden",
    Minutes: "Minuten",
    Seconds: "Sekunden"
  },

  phUserLike_ContentType: {
    News: "News",
    Coupon: "Coupons",
    Event: "Events",
    Location: "Standorte",
    Aktion: "Aktion",
    Menu: "Speisekarte",
    Bonussystem: "Bonusaktionen"
  },

  phRegistration_Title: "Willkommen",
  phRegistr_Tab_Title: "Registriere Dich jetzt kostenlos um viele weitere Vorteile zu genießen.",
  phRegistration_TabName_Register: "Registrieren",
  phRegistration_TabName_Login: "Anmelden",
  phRegistration_LoginTab_ForgetPassword: "Passwort vergessen?",
  phRegistration_RegisterTab_Registerbutton: "Registrieren",
  phRegistration_LoginTab_LoginButton: "Anmelden",
  phRegisteration_Validate_Email: "Die E-Mail ist ungültig",
  phRegisteration_Validate_Password: "Dein Passwort muss aus 8 Stellen, mindestens einem Buchstaben und einer Zahl bestehen.",
  phRegisteration_ForgetPassword_Message: "Wir haben dir eine E-Mail zugeschickt, mit der Du Dein Passwort zurücksetzen kannst. Solltest Du keine E-Mail erhalten haben, überprüfe bitte Deinen Spam-Ordner oder klicke auf \"Erneut anfordern\"",
  phRegistration_ForgetPassword_RequestAgain: "Erneut anfordern",
  phRegistration_CheckPrivacy_Error: "Bitte bestätige unsere rechtlichen Texte",
  phRegistration_Email_PlaceHolder: "E-Mail",
  phRegistration_Password_PlaceHolder: "Passwort",
  phRegistration_GoogleRegistration_Button: "Mit Google fortfahren",
  phRegistration_FacebookRegistration_Button: "Mit Facebook fortfahren",
  phRegistration_ThirdPartyRegistration_Seperator: "oder weiter mit",
  phRegistration_ThirdPartyLogin_Seperator: "oder anmelden mit",


  phRegister_Failed_message: "Die E-Mail <email> ist bereits registert. Bitte melde Dich direkt über die Anmelden-Seite an.",
  phLogin_Failed_message: "Dein Benutzername oder das Passwort ist falsch.",

  phLoginActivation_Title: "Willkommen",
  phLogin_Tab_Title: "Du bist bereits registriert? Super!<phloginTitleBreak>Melde Dich hier mit Deinen Zugangsdaten an und genieße sofort viele weitere Vorteile.",
  phLoginActivation_TitleMessage: "Gleich geschafft!",
  phLoginActivation_ResetPassword: "Aktivierungsmail erneut senden",
  phLoginActivation_Continue: "Weiter",
  phLoginActivation_Login_Title: "Anmeldung",
  phLoginActivation_ForgetPassword: "Passwort vergessen?",
  phLoginActivation_MainMessage: "Bitte bestätige Deine Registrierung, die wir an <email> geschickt haben",
  phLoginActivation_Failed_Message: "Die Registrierung mit der E-Mail <email> wurde noch nicht bestätigt. Bitte prüfe Deinen Posteingang.",

  phForgetPassword_Title: "Passwort vergessen?",
  phForgetPassword_Message: "Bitte gib Deine E-Mail ein, damit wir Dein Passwort zurücksetzen können.",
  phForgetPassword_ResetPassword: "Passwort zurücksetzen",
  phForgetPassword_ValidationMessage: "Entschuldigung! Das hat nicht geklappt, bitte überprüfe Deine Eingabe.",
  phForgetPassword_Email_PlaceHolder: "E-Mail",

  phRegistrationData_Title: "Willkommen",
  phRegistrationData_Label_Name: "Dein Vorname",
  phRegistrationData_Name_PlaceHolder: "Dein Vorname",
  phRegistrationData_Location_Select: "Wähle Deine Lieblingsstandorte aus",
  phRegistrationData_Location_Button: "Standorte auswählen",
  phRegistrationData_SelectedLocation_Button: "Standort ausgewählt",
  phRegistrationData_MultipleSelectedLocation_Button: "Standorte ausgewählt",
  phRegistrationData_Register_Button: "Registrieren",
  phRegistrationData_Location_Validation_Error: "Bitte wählen Sie mindestens einen Ort aus",
  phRegistrationData_Name_Validation_Error: "Der Name darf nicht leer sein.",

  phRegistrationInput_prefix: "Anrede",
  phRegistrationInput_name: "Nachname",
  phRegistrationInput_fname: "Vorname",
  phRegistrationInput_companyAddress: "Firmenadresse",
  phRegistrationInput_co: "C/O",
  phRegistrationInput_address: "Straße & Hausnummer",
  phRegistrationInput_addition: "Zusatz",
  phRegistrationInput_zip_code: "PLZ",
  phRegistrationInput_city: "Ort",
  phRegistrationInput_country: "Land",
  phRegistrationInput_email: "E-Mail",
  phRegistrationInput_password: "Passwort",
  phRegistrationInput_telephone1: "Telefon privat",
  phRegistrationInput_telephone2: "Telefon geschäftlich",
  phRegistrationInput_telephone_mobile: "Telefon mobil",

  phDataInputs_Default_MaxLength: "Bitte maximal {length} Zeichen eingeben.",
  phDataInputs_Default_MinLength: "Bitte mindestens {length} Buchstaben eingeben.",
  phDataInputs_Default_Validate_Letters_Pattern: "Bitte nur Buchstaben eingeben.",
  phDataInputs_Default_Validate_NumbersOnly: "Bitte nur Ziffern eintragen.",
  phDataInputs_Default_Validate_required: "Dieses Feld darf nicht leer sein.",
  phDataInputs_Name_Validate_Required: "Der Name darf nicht leer sein.",
  phDataInputs_Lastname_Validate_Required: "Der Nachname darf nicht leer sein.",
  phDataInputs_Gender_Validate_Required: "Das Geschlecht darf nicht leer sein.",
  phDataInputs_Street_Required: "Die Straße darf nicht leer sein.",
  phDataInputs_Street_Pattern: "Die Straße ist ungültig.",
  phDataInputs_House_Number_Pattern: "Die Hausnummer ist ungültig.",
  phDataInputs_Address_Validate_Required: "Der Adresse darf nicht leer sein.",
  phDataInputs_Address_Validate_Pattern: "Bitte Straße und Hausnummer eingeben.",
  phDataInputs_Zip_code_Validate_Required: "Der Postleitzahl darf nicht leer sein.",
  phDataInputs_Zip_code_Validate_Pattern: "Die Postleitzahl ist ungültig.",
  phDataInputs_City_Validate_Required: "Der Ort darf nicht leer sein.",
  phDataInputs_City_Validate_Pattern: "Der Ort ist ungültig.",
  phDataInputs_Addition_Validate_Required: "Der Zusatz darf nicht leer sein.",
  phDataInputs_Phone_Validate_MinLength: "Bitte mindestens 6 Ziffern eingeben.",
  phDataInputs_Phone_Validate_Pattern: "Ungültige Telefonnummer.",
  phDataInputs_Phone_Validate_Email: "Die E-Mail ist ungültig.",
  phDataInputs_Country_Validate_Required: "Das Land darf nicht leer sein.",
  phDataInputs_Co_Validate_Required: "C/O darf nicht leer sein.",
  phDataInputs_bday_ymd_DateNotValid: "Geburtsdatum ist ungültig.",
  phDataInputs_bday_ymd_Validate_Required: "Geburtsdatum darf nicht leer sein.",

  phLocationDialog_ConfirmButton: "Bestätigen",
  phLocationDialog_Title: "Standort wählen",
  phLocationDialog_Description: "Bitte wähle Deine bevorzugten Standorte aus, so dass Du nur die für Dich relevanten Informationen angezeigt bekommst. Deine Auswahl kannst Du jederzeit im Bereich der Standorte anpassen.",

  phUserProfile_MyProfile: "Mein Profil",
  phUserProfile_Account: "Mein Konto",
  phUserProfile_Order: "Meine Bestellungen",
  phUserProfile_BillingInfo: "Rechnungsinformation",
  phUserProfile_Delivery_Address: "Meine Lieferadressen",
  phUserProfile_User_Addresses: "Meine Adressen",
  phUserProfile_BonusPunkte: "Meine Bonuspunkte",
  phUserProfile_Webgutschein: "Mein Webgutschein",
  phUserProfile_MyLike: "Meine Likes",
  phUserProfile_Feedback: "Feedback",
  phUserProfile_MyAccount_Description: "Bearbeite Deinen Namen, Geschlecht und Geburtstag.",
  phUserProfile_Order_Description: "Hier kannst Du Deine Bestellungen einsehen.",
  phUserProfile_MyAddress_Description: "Bearbeite hier Deine Rechnungs- und Lieferadressen.",
  phUserProfile_PasswordChange_Description: "Du möchtest Dein Passwort ändern? Kein Problem.",
  phUserProfile_WebGutschein_Description: "Hier kannst Du Deinen Gutscheincode einsehen oder einen Code generieren.",
  phUserProfile_MyLike_Description: "Finde schnell Deine gelikten Inhalte wieder.",
  phUserProfile_Feedback_Description: "Du möchtest uns Feedback geben? Vielen Dank!",
  phUserProfile_BonusPoint_Description: "Hier kannst Du den aktuellen Stand Deiner Bonuspunkte einsehen.",
  phUserProfile_Tags_Subtext: "Hier kannst Du Deine Vorlieben hinterlegen.",

  phUserProfileDetail_Header: "Meine Einstellungen",
  phUserProfileDetail_PlaceHolder_fName: "Vorname",
  phUserProfileDetail_PlaceHolder_Name: "Nachname",
  phUserProfileDetail_PlaceHolder_Email: "E-Mail",
  phUserProfileDetail_PlaceHolder_Birthday: "Geburtstag",
  phUserProfileDetail_PlaceHolder_Gender: "Geschlecht",
  phUserProfileDetail_PlaceHolder_PostalCode: "Postleitzahl",
  phUserProfileDetail_Label_ChangePassword: "Passwort ändern",
  phUserProfileDetail_Label_Logout: "Abmelden",
  phUserProfileDetail_Option_Title: "Einstellungen",
  phUserProfileDetail_Tab_Header_AccounntInfo: "Mein Konto",
  phUserProfileDetail_Tab_Header_Order: "Meine Bestellungen",
  phUserProfileDetail_Tab_Header_Addresses: "Meine Adressen",
  phUserProfileDetail_Tab_Header_Preferences: "Meine Vorlieben",
  phUserProfileDetail_Billing_Address: "Meine Rechnungsadresse",
  phUserProfileDetail_Delivery_Address: "Meine Lieferadressen",
  phUserProfileDetail_Botton_Label_NewAddress: "Neue Adresse",
  phUserProfileDetail_Save_User_Info: "Speichern",
  phUserProfileDetail_Tags_Subtext: "Hier kannst Du Deine Vorlieben hinterlegen und unser Angebot danach sortieren.",
  phUserProfileDetail_Tags_Title: "Vorlieben",
  phUserProfileDetail_Empty_Order: "Sobald Du etwas in unserem Shop bestellt hast, kannst Du hier Deine Bestellhistorie einsehen.",
  phUserProfileDetail_Order_List_Header: "Deine Bestellung vom:",
  phUserProfileDetail_Order_Location: "Standort:",
  phUserProfileDetail_Order_Amount: "Gesamtbetrag:",

  phUserOrderDetail_Date_Time: "Datum/Uhrzeit:",
  phUserOrderDetail_Order_Service: "Bestelltyp:",
  phUserOrderDetail_Payment_Type: "Zahlungsart:",
  phUserOrderDetail_Order_Nr: "Bestellnummer:",
  phUserOrderDetail_State: "Status:",
  phUserOrderDetail_State_In_Progress: "In Bearbeitung",
  phUserOrderDetail_State_Done: "Abgeschlossen",
  phUserOrderDetail_Item_Header: "Artikel",
  phUserOrderDetail_Price_Header: "Preis",
  phUserOrderDetail_NoCOO_Pin_Info_Label: "Pin zur Anzeige Deiner Rechnung",
  phUserOrderDetail_NoCOO_Pin: "PIN:",
  phUserOrderDetail_Billing_Button_Label: "Zur Rechnung",
  phUserOrderDetail_GroupName: "Gruppenname: {groupName}",

  phUserProfileDetail_Delete_Account: "Profil löschen",
  phDeleteAccountDialog_Content: "Bist Du sicher, dass Du Dein Profil bei uns löschen möchstest?<br>Durch das Löschen gehen alle gespeicherten Daten verloren und Du wirst automatisch abgemeldet. Dieser Vorgang kann nicht rückgängig gemacht werden.",
  phDeleteAccountDialog_Confirm: "Dein Profil wurde erfolgreich gelöscht",
  phDeleteAccountDialog_Confirm_Text: "Dein Profil wurde erfolgreich gelöscht. Bitte drücke auf die nachfolgende Schaltfläche, um zur Startseite zurückzukehren.",

  phUserProfileAddress_MainAddress_Title: "Meine Rechnungsadresse",
  phUserProfileAddress_DeliVeryAddress_Title: "Meine Lieferadresse",
  phUserProfileAddress_NewDeliveryAddress_Title: "Neue Lieferadresse",
  phUserProfileAddress_Save_User_Info: "Speichern",
  phUserProfileAddress_Delete_Address_Button: "Adresse löschen",
  phUserProfileAddress_Announce_Dialog_Title: "Adresse löschen",
  phUserProfileAddress_Announce_Dialog_Content: "Möchtest Du diese Adresse wirklich löschen?",
  phUserProfileAddress_Announce_Dialog_FirestBtn_Label: "Ja",
  phUserProfileAddress_Announce_Dialog_SecondBtn_Label: "Nein",

  phChangePassword_Title: "Passwort ändern",
  phChangePassword_Message: "Bitte gib zum Ändern Dein aktuelles sowie ein neues Passwort ein",
  phChangePassword_ChangePassword_button: "Passwort ändern",
  phChangePassword_Label_OldPassword: "Altes Passwort",
  phChangePassword_Label_NewPassword: "Neues Passwort",
  phChangePassword_Label_confirmPassword: "Passwort bestätigen",
  phChangePassword_Validate_Password: "Dein Passwort muss aus 8 Stellen, mindestens einem Buchstaben und einer Zahl bestehen.",
  phChangePassword_Validate_Password_Required: "Das Alte Passwort darf nicht leer sein.",
  phChangePassword_Confirm_Password: "Bitte gib das gleiche Passwort erneut ein",

  phFeedback_Title: "Feedback",
  phFeedback_Modal_Title: "Bewertung",
  phFeedback_Button_Rate: "Ich war voll zufrieden!",
  phFeedback_Button_Feedback: "Verbesserungsvorschläge & Kritik",
  phFeedback_Message: "Das Team von <customer> hofft, dass Du einen guten Aufenthalt hattest und dass Dir die Nutzung der App gefallen hat. Klicke für Feedback bitte auf den jeweiligen Button, je nachdem ob Du mit der App zufrieden bist, oder Du Verbesserungsvorschläge hast.",

  phWebvoucher_Detail_Value: "Wert",
  phWebvoucher_Detail_Desired_Value: "Gewünschter Wert",
  phWebvoucher_Detail_Number_Of_Persons: "Personenanzahl",
  phWebvoucher_Detail_Selected_Number_Of_Persons: "Personen",
  phWebvoucher_Detail_Selected_Single_Person: "Person",
  phWebvoucher_Detail_Email_Delivery: "Download",
  phWebvoucher_Detail_Post_Delivery: "Postversand",
  phWebvoucher_Detail_Free_Delivery: "gebührenfrei",
  phWebvoucher_Detail_Plus_Cost_Delivery: "zzgl. Versandkosten",
  phWebVoucher_Detail_Tab_Overview: "Übersicht",
  phWebVoucher_Detail_Tab_Preview: "Vorschau",
  phWebVoucher_Detail_Show_More: "Mehr anzeigen",
  phWebVoucher_Detail_Show_Less: "Weniger anzeigen",

  phWebvoucher_Title: "Code hinzufügen",
  phWebvoucher_button_continue: "Weiter",
  phWebvoucher_button_ToShop: "Zum Shop",
  phWebvoucher_vouchercode_PlaceHolder: "Code hier eingeben",
  phWebvoucher_EnterCode_Title: "Hast Du bereits einen Gutscheincode?",
  phWebvoucher_EnterCode_Description: "Gib hier bitte die 18-stellige Nummer ein.",
  phWebvoucher_CreateVoucher_Button: "Code erstellen",
  phWebVoucher_CreateVoucher_Title: "Du Hast noch keinen Gutscheincode?",
  phWebVoucher_CreateVoucher_Description: "Um Bonuspunkte zu sammeln oder Guthaben aufzuladen benötigst Du einmalig einen Gutscheincode, klicke auf \"Code erstellen\" um diesen jetzt zu erzeugen.",
  phWebvoucher_Error_Blocked: "Der Code wurde zu häufig falsch eingeben. Bitte versuche es in <delaytime> Minuten erneut.",
  phWebvoucher_Error_UsedWebvoucher: "Der eingegebene Code ist ungültig",
  phWebvoucher_Error_WrongWebvoucher: "Der eingegebene Code ist ungültig",
  phWebvoucher_Validate_Code: "Der eingegebene Code ist ungültig",
  phWebvoucher_MuchTry_Title: "Du hast bereits einige Gutscheincodes...",
  phWebvoucher_MuchTry_Description: "Du hast bereits mehrfach einen neuen Gutscheincode erzeugt. Bitte wende Dich an unser Servicepersonal in einem unserer Standorte, wir helfen dir gerne weiter.",
  phWebvoucher_MuchTry_Button: "Schließen",

  phWebvoucherDetail_Title: "Dein QR Code",
  phWebvoucherDetail_button_Title: "Code entfernen",
  phWebvoucherDetail_Date_Caption: "Daten vom",
  phWebvoucherDetail_Button_Refresh: "Aktualisieren",

  phWebvoucherModal_Header: "Code entfernen",
  phWebvoucherModal_Text: "Solltest Du über mehr als einen Code verfügen, kannst du hier den hinterlegten Code entfernen und einen anderen Code registrieren. Alle Inhalte Deines bisherigen Codes bleiben selbstverständlich darauf gespeichert und können jederzeit wieder hinzugefügt werden.",
  phWebvoucherModal_TextNote: "<b>WICHTIG:</b> Bitte notiere Dir Deinen aktuellen Code, um diesen später wieder verwenden zu können, dieser lautet",
  phWebvoucherModal_RemoveButton_Label: "Code entfernen",

  phBonusAction_Your_QR: "Dein QR Code",
  phBonusAction_QR_Text: "Öffne hier Deinen QR-Code, um Bonuspunkte zu sammeln oder Prämien einzulösen.",
  phBonusAction_Create_QR: "Dein QR Code",
  phBonusAction_Create_QR_Text: "Um Bonuspunkte zu sammeln oder Prämien einzulösen, benötigst Du einmalig einen QR-Code. Erstelle ihn jetzt hier.",
  phBonusAction_Cost_Points: "<points> Punkte",
  phBonusAction_Circle_Points: "Punkte",
  phBonusAction_Redeem_Benefits: "Jetzt Einlösen!",
  phBonusAction_Register_Benefits: "Jetzt Anmelden!",
  phBonusAction_Benefits: "Prämien",
  phBonusAction_Costs_inBasket_Points: "{benefitCosts} von Deinen {currentPoints} Punkten befinden sich im Warenkorb und werden eingelöst.",
  phBonusAction_Current_Points: "Deine Punkte:",
  phBonusAction_To_Benefits: "Zu den Details",
  phBonusAction_Load_Points_Error: "Die Punkte können momentan nicht angezeigt werden",

  phBonusActionDetails_Location: "Teilnehmende Standorte",

  phBenefit_Redeem_Dialog_Title: "Wie möchtest Du die Bonuspunkte einlösen?",
  phBenefit_Redeem_Dialog_InStore_Desc: "Den QR-Code an der Kasse vorzeigen und die Punkte vor Ort einlösen.",
  phBenefit_Redeem_Dialog_InStore_Btn: "Vor Ort",
  phBenefit_Redeem_Dialog_Online_Desc: "Punkte direkt online einlösen und die Prämie in den Warenkorb legen",
  phBenefit_Redeem_Dialog_Online_Btn: "Jetzt einlösen",
  phBenefit_Redeem_LocationAndOrderType_Dialog_Title: "Wo möchtest Du die Bonuspunkte einlösen?",
  phBenefit_Redeem_LocationAndOrderType_Dialog_Tab_Location_Desc: "Bitte wähle einen Standort um Deine Bonuspunkte einzulösen.",
  phBenefit_Redeem_LocationAndOrderType_Dialog_Tab_OrderType_Desc: "Wie möchtest Du die Bonuspunkte bei uns einlösen?",
  phBenefit_Redeem_LocationAndOrderType_Dialog_Tab_OrderType_Empty: "Leider kann die ausgewählte Prämie an diesem Standort nicht eingelöst werden. Bitte versuche es mit eine andere Prämie.",
  phBenefit_Redeem_Table_Login_Required_Dialog_Title: "Tischcode benötigt",
  phBenefit_Redeem_Table_Login_Required_Dialog_Desc: "Bitte scanne zuerst einen Tischcode, bevor Du die Bonuspunkte einlösen kannst.",
  phBenefit_Redeem_OrderType_Not_Valid_Dialog_Title: "Bestelltyp ungültig",
  phBenefit_Redeem_OrderType_Not_Valid_Dialog_SubText: "Für Deine ausgewählte Bestelltyp können leider keine Bonuspunkte eingelöst werden, bitte wähle einen andere Bestelltyp aus.",
  phBenefit_Redeem_OrderType_Not_Valid_Dialog_Change_Btn: "Bestelltyp wechseln",
  phBenefit_Redeem_OrderType_Not_Valid_Dialog_Cancel_Btn: "Abbrechen",
  phBenefit_Redeem_No_Product_Dialog_Title: "Prämie nicht einlösbar",
  phBenefit_Redeem_No_Product_Dialog_Info: "Info Leider kann die Prämie nicht eingelöst werden. Bitte wähle eine andere Prämie aus.",
  phBenefit_Redeem_Product_NotAvailable_Dialog_Title: "Prämie nicht verfügbar",
  phBenefit_Redeem_Product_NotAvailable_Dialog_Info: "Leider ist die Prämie  derzeit nicht verfügbar. Bitte versuche es morgen erneut.",
  phBenefit_Redeem_Cost_Points_Info: "{points} Punkte",
  phBenefit_Redeem_Not_Enough_Points_Dialog_Title: "Nicht genug Punkte vorhanden.",
  phBenefit_Redeem_Not_Enough_PointsDialog_SubText: "Aus dieser Aktion haben Sie bereits Benefits im Wert von {consumedPoints} im Warenkorb. Ihre verfügbare Punkte für diese Aktion betragen {availablePoints}. \nBitte entfernen Sie einen anderen Benefit aus dem Warenkorb, um dieses zu buchen.",

  phCoupon_Show_Code: "Couponcode anzeigen",
  phCoupon_Redeem_Now: "Jetzt im Shop einlösen",
  phCoupon_Members: "Nur für Mitglieder",
  phCouponDetail_Content: "Du musst bei <customer> registriert sein, um diesen Coupon nutzen zu können. Noch kein Mitglied? Dann registriere Dich jetzt!",
  phCoupon_Expires_On: "Läuft am",
  phCoupon_Expires_On_End: "ab",
  phCoupon_Expires_Today: "Läuft heute ab",

  phSelectedLayer_Title: "Standort wählen",
  phSelectedLayer_Description: "Bitte wähle Deinen gewünschten Standort aus, diesen kannst Du jederzeit über die Titelleiste wechseln.",

  phMenuGroup_Header: "Speisekarte",
  phMenuGroup_DialogHeader: "Alle Kategorien",

  phMenu_DislikeSeperator_title: "Mag ich nicht",

  phMenuDetail_ExtragroupTitle: "Abfrage",
  phMenuDetail_Required: "Pflichtauswahl",

  phLoginDialog_Title: "Nur für <customer> Mitglieder!",
  phLoginDialog_Content: "Du musst bei <customer> registriert sein, um diese Funktion nutzen zu können. Noch kein Mitglied? Dann registriere Dich jetzt!",
  phLoginDialog_Content_ModuleName: "Du musst bei <customer> registriert sein, um den Bereich <modulename> nutzen zu können. Noch kein Mitglied? Dann registriere Dich jetzt!",

  phUserLike_Header: "Meine Likes",

  phProductDetail_Description: "Beschreibung",
  phProductDetail_Overview: "Übersicht",
  phProductDetail_CO2: "CO2",
  phProductDetail_Additives: "Zusatzstoffe",
  phProductDetail_Nutrition: "Nährwerte",
  phProductDetail_Allergy: "Allergene",
  phProductDetail_Content: "Zutatenverzeichnis",
  phProductDetail_Distributor: "Verantwortliches Unternehmen",
  phProductDetail_Labelling: "Produktinformationen",
  phProductDetail_Date_Caption: "Speisekarte vom ",
  phProductDetail_AdditionalInformations: "Weitere Information",
  phProductDetail_ShowAdditionalOption: "Weitere Optionen anzeigen",
  phProductDetail_ShowLessOption: "Weniger Optionen anzeigen",
  phProductDetail_InfosNotForCustomizedOrders_TEXT: "Angaben beziehen sich nicht auf personalisierte Bestellungen",
  phProductDetail_Announce_Dialog_Title: "Keine Bestellung möglich",
  phProductDetail_Announce_Dialog_Content: "Du befindest Dich in unserem 'stöbern' Bereich, in welchem keine Bestellung getätigt werden kann. Bitte wähle einen anderen Bestelltyp aus.",
  phProductDetail_Announce_Dialog_FirstBtn_Label: "Bestelltyp wählen",
  phProductDetail_Announce_Dialog_SecondBtn_Label: "Weiter stöbern",
  phProductDetail_CurrentlyNotAvailable: "momentan nicht verfügbar",
  phProductDetail_includeDeposit: "inkl. {deposit} Pfand",
  phProductDetail_plusDeposit: "zzgl. {deposit} Pfand",
  phProductDetail_Alcohol_Content: "Alkoholgehalt {value}",
  phProductDetail_Caffeine_Content: "Koffeingehalt {value}",
  phProductDetail_EnterYourDesiredAmount: "Gib Deinen Wunschbetrag ein",
  phProductDetail_prepackaged: "Vorverpackt",

  phExternalLinkModal_confirmation_Title: "Du verlässt unsere Anwendung",
  phExternalLinkModal_confirmation_Title_eMenu: "Du verlässt unser eMENU",
  phExternalLinkModal_confirm_Button_Text: "Weiter",

  phConfirmDialog_NoCOO_Title: "Weiterleitung zum Rechnungsportal",
  phConfirmDialog_NoCOO_Text: "Bitte betätige die nachfolgende Schaltfläche, um zu unserem Rechnungsportal weitergeleitet zu werden.",
  phConfirmDialog_NoCOO_Button: "Weiter",

  phMenuService_Choice: "Bestelltyp",
  phMenuService_PlsChooseService_TEXT: "Bitte wähle aus, wie Du bei uns bestellen möchtest.",
  phMenuService_ViewMenu: "Speisekarte ansehen",
  phMenuService_ViewMenu_SubText: "Möchtest Du einfach nur stöbern und keine Bestellung aufgeben?",
  phMenuService_OderToTable: "Bestellung zum Tisch",
  phMenuService_OrderToTable_SubText: "Im Restaurant direkt mit QR-Code am Tisch bestellen.",
  phMenuService_TakeAway: "Abholung",
  phMenuService_TakeAway_SubText: "Jetzt unkompliziert bestellen und gleich vor Ort abholen.",
  phMenuService_TakeAway_Group: "Gruppenbestellung Abholung",
  phMenuService_Delivery: "Lieferung",
  phMenuService_Delivery_SubText: "Einfach Deine Position angeben, Standort auswählen und los.",
  phMenuService_Delivery_Group: "Gruppenbestellung Lieferung",

  phMenuService_Webvoucher_WithCharging: "Gutschein & Guthaben",
  phMenuService_Webvoucher_SubText_WithCharging: "Hier kannst Du Dein Guthaben aufladen, oder Gutscheine bestellen.",
  phMenuService_Webvoucher: "Gutschein",
  phMenuService_Webvoucher_SubText: "Hier Gutscheine bestellen und gleich per E-Mail erhalten.",

  phWebshop_ShippingCart_Nav_Header: "Warenkorb",
  phWebshop_OrderData_Nav_Headero: "Kundendaten",
  phWebshop_Payment_Nav_Header: "Bezahlung",
  phWebshop_FreeShippingAt_BASE: "Füge noch Artikel im Wert von {amount} hinzu, um keine Liefergebühren zu zahlen.",
  phWebshop_PleaseChooseDeliveryCountry: "Bitte wähle das Lieferland aus:",
  phWebshop_SelectPickupTime: "Bitte wähle Deine gewünschte Abholzeit aus.",
  phWebshop_SelectPickupTime_subText: "Bis wann möchtest du abholen?",
  phWebshop_SelectDeliveryTime: "Bitte wähle Deine gewünschte Lieferzeit aus.",
  phWebshop_SelectDeliveryTime_subText: "Voraussichtlicher Lieferzeitpunkt",
  phWebshop_SelectOrderSubmissionTime: "Bitte wähle Deine gewünschte Bestellzeit aus.",
  phWebshop_SelectOrderSubmissionTime_subText: "Bis wann möchtest du bestellen?",
  phWebshop_Pickup_Day_Label: "Abholtag",
  phWebshop_Delivery_Day_Label: "Liefertag",
  phWebshop_AsSoonAsPossible: "Schnellstmöglich",
  phWebshop_Pickup_Time_Label: "Abholzeit",
  phWebshop_Delivery_Time_Label: "Lieferzeit",
  phWebshop_ServiceSubmissionDay_Label: "Bestelltag",
  phWebshop_ServiceSubmissionTime_Label: "Bestellzeit",
  phWebshop_InHause_Time: "Bestellzeit: Jetzt",
  phWebshop_NoDelivery_Time: "Heute ist leider keine Lieferung möglich",
  phWebshop_NoPickup_Time: "Heute ist leider keine Abholung möglich",
  phWebshop_NoInHause_Time: "Heute ist leider keine Bestellung zum Tisch möglich",
  phWebshop_Item_Show_Comment: "Anmerkung",
  phWebshop_Item_Hide_Comment: "Anmerkung",
  phWebshop_Item_Benefit: "Prämie",
  phWebshop_ShippingCart_Total: "Total",
  phWebshop_ShippingCart_MinimumDelivery: "Mindestbestellwert",
  phWebshop_Shippingcart_next: "Jetzt bestellen",
  phWebshop_Shippingcart_tip: "Trinkgeld",
  phWebshop_Shippingcart_DeliveryFee: "Liefergebühr",
  phWebshop_Shippingcart_SumOfProducts: "Summe",
  phWebshop_Shippingcart_IncludeDeposit_BASE: "inkl. {deposit} Pfand",
  phWebshop_Recommendation_Title: "Zu Deiner Bestellung empfehlen wir:",
  phWebshop_View_Cart: "Warenkorb ansehen",
  phWebshop_Shippingcart_Only_Benefit: "Es ist nicht möglich, nur Benefit Produkte zu bestellen. Bitte weitere Artikel hinzufügen.",

  phWebshop_includeDeposit: "inkl. Pfand",
  phWebshop_plusDeposit: "zzgl. Pfand",

  phOrderData_Username_Announce: "Du bist angemeldet als",
  phOrderData_Guest_register_comment: "Registriere Dich in wenigen Schritten, um alle Vorteile zu nutzen und Deine nächste Bestellung schneller und einfacher abzuschließen.",
  phOrderData_Order_As_Guest: "Oder bestelle als Gast",
  phOrderData_Order_Following_Information: "Für die weitere Bearbeitung benötigen wir noch folgende Angaben von Dir.",
  phOrderData_selectBillAddress: "Deine Rechnungsadresse",
  phOrderData_selectAddress: "Lieferadresse auswählen",
  phOrderData_selectNewAddress: "Neue Lieferadresse auswählen",
  phOrderData_addNewAddress: "Neue Adresse anlegen",
  phOrderData_Billing_Address_Is_Delivery_Address_Title: "Lieferadesse",
  phOrderData_Billing_Address_Is_Delivery_Address_Label: "Lieferung an Rechnungsadresse",
  phOrderData_Different_Delivery_Address: "Abweichende Lieferadresse",
  phOrderData_Enter_Different_Delivery_Address: "Abweichende Lieferadresse eingeben",
  phOrderData_CurrentlyUsedDeliveryAddress: "Deine Lieferadresse: {address}, {zip} {city}",
  phOrderData_CurrentlyUsedBillingAddress: "Deine Rechnungsadresse: {address}, {zip} {city}",

  phPayment_Webvoucher_Usage: "Gutschein verwenden",
  phPayment_RedeemWebvoucher: "Gutscheincode einlösen (18-Stellig)",
  phPayment_Webvoucher_Info_BASE: "Dein Gutschein ({Nr}) hat einen Wert von {Amount}",
  phPayment_Webvoucher_Info_Discount_BASE: "Dein Gutschein ({Nr}) hat einen Wert von {Amount} und einen Rabatt in Höhe von {Discount}",
  phPayment_Webvoucher_OnlyNr_BASE: "Dein Gutschein hat die Nummer {SimpleNr}",
  phPayment_Webvoucher_OnlyNrAndDiscount_BASE: "Dein Gutschein ({Nr}) hat einen Rabatt in Höhe von {Discount}",
  phPayment_Validate_WebvoucherPattern: "Gutschein-Code muss eine 18-stellige Nummer sein",
  phPayment_Validate_WebvoucherExists: "Kein gültiger Gutschein konnte gefunden werden",
  phPayment_PayPal: "PayPal",
  phPayment_Accounting: "Auf Rechnung",
  phPayment_CashlessTakeaway: "Bargeldlos bei Abholung",
  phPayment_CashlessDelivery: "Bargeldlos bei Lieferung",
  phPayment_CashDelivery: "Bar bei Lieferung",
  phPayment_PayOnCollection: "Bezahlung bei Abholung",
  phPayment_Webvoucher: "Webgutschein",
  phPayment_PayAtWaiter: "Zahlen beim Servicepersonal",
  phPayment_FinalPrice: "Zu zahlender Betrag",
  phPayment_ChooseYourPaymentMethod: "Wähle Deine Zahlungsart",
  phPayment_MorePaymentMethods: "Weitere Zahlungsmöglichkeiten",
  phPayment_AcceptTerms_BASE: "Mit der zahlungspflichtigen Bestellung akzeptiere ich die {customer}-{terms}",
  phPayment_OrderNowWithCosts: "Jetzt kostenpflichtig bestellen",
  phPayment_PayNow: "Jetzt bezahlen",
  phPayment_CommentToYourOrder: "Hast Du Anmerkungen zur Bestellung?",
  phPayment_UnsupportedCardType_Title: "Nicht unterstützer Kartentyp",
  phPayment_UnsupportedCardType_Content: "Der Kartentyp dieser Nummer wird nicht als Zahlungsmethode unterstützt. Bitte überprüfe Deine eingegebene Kartennummer oder verwende eine andere Zahlungsart.",
  phPayment_UnsupportedCardType_Button: "Zurück",
  phPayment_NoDeliveryAddress: "Es konnte keine Lieferadresse ermittelt werden. Bitte Liefer- oder Rechnungsadresse angeben.",

  phPayment_MethodName_amex: "American Express",
  phPayment_MethodName_applepay: "Apple Pay",
  phPayment_MethodName_diners: "Diners",
  phPayment_MethodName_directEbanking: "Sofort",
  phPayment_MethodName_discover: "Discover",
  phPayment_MethodName_jcb: "JCB",
  phPayment_MethodName_mc: "Mastercard",
  phPayment_MethodName_paypal: "PayPal",
  phPayment_MethodName_paywithgoogle: "Google Pay",
  phPayment_MethodName_visa: "Visa",
  phPayment_MethodName_unknown: "Unbekannt",
  phPayment_MethodName_Cash_DeliveryTakeAway: "Bar",
  phPayment_MethodName_ec: "EC",
  phPayment_MethodName_EcNational: "Ec-National",
  phPayment_MethodName_EcInternational: "Ec-International",
  phPayment_MethodName_EcForeign: "Ec-Ausland",
  phPayment_MethodName_ECustomerCard: "Ec-Kundenkarte",
  phPayment_MethodName_Breuninger: "Breuninger",
  phPayment_MethodName_ecCash: "Ec-Cash",
  phPayment_MethodName_sonstigeKreditkarten: "Sonstige Kreditkarten",
  phPayment_MethodName_AdrevaMacao: "AdrevaMacao",
  phPayment_MethodName_IKEAFamilyCard: "IKEAFamilyCard",
  phPayment_MethodName_VisaDebit: "Visa Debit",
  phPayment_MethodName_MCDebit: "MC Debit",
  phPayment_MethodName_Maestro: "Maestro",
  phPayment_MethodName_VPay: "VPay",
  phPayment_MethodName_Postcard: "Postcard",
  phPayment_MethodName_PayPalPicturePayment: "PayPalPicturePayment",
  phPayment_MethodName_Deposit: "Einzahlung",
  phPayment_MethodName_Payout: "Auszahlung",
  phPayment_MethodName_twint: "TWINT",
  phPayment_MethodName_WebInvoice: "WebInvoice",
  phPayment_MethodName_ZahlungAnstehend: "Zahlung Anstehend",
  phPayment_MethodName_CashController: "CashController",
  phPayment_MethodName_PayPerApp: "PayPerApp",
  phPayment_MethodName_Cashess_Delivery: "Bargeldlos",
  phPayment_MethodName_PayDirect: "Paydirekt",
  phPayment_MethodName_LunchCard: "Lunch Card",
  phPayment_MethodName_LunchCheckCard: "Lunch Check Card",
  phPayment_MethodName_MaestroCH: "Maestro CH",
  phPayment_MethodName_PowerCard: "Power Card",
  phPayment_MethodName_Loeb: "Loeb",
  phPayment_MethodName_Manorcard: "Manorcard",
  phPayment_MethodName_WIRcard: "WIRcard",
  phPayment_MethodName_Reka: "Reka",
  phPayment_MethodName_Giftcard: "Giftcard",
  phPayment_MethodName_ChinaUnionPay: "China UnionPay",
  phPayment_MethodName_Alipay: "Alipay",
  phPayment_MethodName_WeChat: "WeChat",
  phPayment_MethodName_Sodexo: "Sodexo",
  phPayment_MethodName_TWINTTerminal: "Twint Terminal",
  phPayment_MethodName_OnlineZahlung: "Online Zahlung",
  phPayment_MethodName_AmazonPay: "AmazonPay",
  phPayment_MethodName_klarna_paynow: "Klarna Pay Now",
  phPayment_MethodName_EPS_AT: "EPS AT",
  phPayment_MethodName_Paysafecard: "PaySafecard",
  phPayment_MethodName_Wallet: "Wallet",
  phPayment_MethodName_Sepa: "SEPA",
  phPayment_MethodName_Girocard: "Girocard",
  phPayment_MethodName_Voucher: "Webgutschein",
  phPayment_MethodName_MPA: "Auf Rechnung",
  phPayment_MethodName_Cashless_DeliveryTakeaway: "Bargeldlos",
  phPayment_MethodName_PayAtPOS: "Zahlen am POS",
  phPayment_MethodName_scheme: "Kartenzahlung",

  phHome_Today: "Heute",

  phArticleCard_ArticleUnavailable: "Dieser Artikel ist leider momentan nicht verfügbar",
  phArticleCard_Recipe_Price_from: "ab",

  phAvailableService_title_Delivery: "Schön, dass Du bei uns bestellen möchtest.",
  phAvailableService_title_Tekeaway: "Schön, dass Du bei uns zur Abholung bestellen möchtest.",
  phAvailableService_title_InHouse: "Schön, dass Du bei uns \"am Tisch\" bestellen möchtest.",
  phAvailableService_title_OpenTime: "Schön, dass Du bei uns bestellen willst!",
  phAvailableService_content_Delivery: "Aktuell haben wir leider geschlossen, wir nehmen Deine Bestellung aber gerne bereits entgegen und beliefern Dich innerhalb unserer Öffnungszeiten. Wähle im nächsten Schritt einfach Deine gewünschte Lieferzeit aus",
  phAvailableService_content_Tekeaway: "Aktuell haben wir leider geschlossen, wir nehmen Deine Bestellung aber gerne bereits entgegen, so dass Du diese innerhalb unserer Öffnungszeiten abholen kannst. Wähle im nächsten Schritt einfach Deine gewünschte Abholzeit aus",
  phAvailableService_content_NoValidTime_Delivery: "Leider sind keine Lieferzeiten mehr verfügbar.",
  phAvailableService_content_NoValidTime_Takeaway: "Leider sind keine Abholzeiten mehr verfügbar.",
  phAvailableService_content_InHouse: "Leider möchtest Du außerhalb unserer Bestellzeiten bestellen. Diese lauten:",
  phAvailableService_content_OpenTime: "Wie es aussieht haben wir gerade geschlossen. Bitte beachte unsere Öffnungszeiten bei Deiner Bestellung.",

  phMenuChangeLocationDialog_YouAreInLocation_BASE: "Du befindest Dich in {location}.",
  phMenuChangeLocationDialog_YouAreKmAway_BASE: "Du bist > {distance} km vom Restaurant entfernt.",
  phMenuChangeLocationDialog_Address: "Adresse",
  phMenuChangeLocationDialog_Opentimes: "Öffnungszeiten",
  phMenuChangeLocationDialog_ChangeLocation: "Standort wechseln",
  phMenuChangeLocationDialog_ChangeService: "Bestellart wechseln",

  phOrderDataInputs_prefix: "Anrede",
  phOrderDataInputs_fname: "Vorname",
  phOrderDataInputs_name: "Name",
  phOrderDataInputs_companyAddress: "Firmenadresse",
  phOrderDataInputs_co: "C/O",
  phOrderDataInputs_address: "Straße & Hausnummer",
  phOrderDataInputs_street: "Straße",
  phOrderDataInputs_house_number: "Hausnummer",
  phOrderDataInputs_addition: "Zusatz",
  phOrderDataInputs_zip_code: "PLZ",
  phOrderDataInputs_city: "Ort",
  phOrderDataInputs_country: "Land",
  phOrderDataInputs_email: "E-Mail",
  phOrderDataInputs_telephone1: "Telefon privat",
  phOrderDataInputs_telephone2: "Telefon geschäftlich",
  phOrderDataInputs_telephone_mobile: "Telefon mobil",
  phOrderDataInputs_fax: "Fax",
  phOrderDataInputs_privatAccess: "Erreichbarkeit von - Erreichbarkeit bis (privat)",
  phOrderDataInputs_workAccess: "Erreichbarkeit von - Erreichbarkeit bis (geschäftlich)",
  phOrderDataInputs_bday_ymd: "Geburtsdatum",

  phOrderDataInputs_Name_Validate_Error: "Der Name darf nicht leer sein.",
  phOrderDataInputs_Family_Validate_Error: "Der Nachname darf nicht leer sein.",
  phOrderDataInputs_Gender_Validate_Error: "Das Geschlecht darf nicht leer sein.",
  phOrderDataInputs_address_Validate_Error: "Der Adresse darf nicht leer sein.",
  phOrderDataInputs_zip_code_Validate_Error: "Der Postleitzahl darf nicht leer sein.",
  phOrderDataInputs_city_Validate_Error: "Die Ort darf nicht leer sein.",
  phOrderDataInputs_addition_Validate_Error: "Der Zusatz darf nicht leer sein.",
  phOrderDataInputs_country_Validate_Error: "Das Land darf nicht leer sein.",
  phOrderDataInputs_co_Validate_Error: "C/O darf nicht leer sein.",
  phOrderDataInputs_bday_ymd_DateNotValid_Error: "Geburtsdatum ist ungültig.",
  phOrderDataInputs_bday_ymd_Validate_Error: "Geburtsdatum darf nicht leer sein.",

  ph_menuLocation_Select_PostalCode: "Bitte gib hier Deine Postleitzahl ein",
  ph_menuLocation_Search: "PLZ oder Stadt eingeben",
  ph_menuLocation_cityList: "Ort auswählen",
  ph_menuLocation_ZipCode_Warning_Title: "Wohin möchtest Du beliefert werden?",
  ph_menuLocation_ZipCode_Warning_Content: "Bitte gib Deine PLZ ein, damit wir prüfen können, ob Du Dich in unserem Liefergebiet befindest.",
  ph_menuLocation_ZipCode_Warning_BtnLabel: "PLZ eingeben",
  ph_menuLocation_ZipCode_Warning_Option: "Sollten wir Dich nicht beliefern können, kannst Du Deine Bestellung natürlich auch gerne bei uns abholen. Wähle hierfür bitte den Bestelltyp „Abholung“ aus.",
  ph_menuLocation_Other_Postalcode: "PLZ ändern",
  ph_menuLocation_Your_Current_Location: "Aktuelle Postleitzahl: ",
  ph_menuLocation_Your_Current_Address: "Aktuelle Adresse: {address}",
  ph_menuLocation_Announce_Dialog_Title: "Keine Lieferung möglich",
  ph_menuLocation_Announce_Dialog_Content: "Deine aktuelle Position können wir leider nicht beliefern. Bitte gibt eine andere Postleitzahl an, oder ändere den Bestelltyp.",
  ph_menuLocation_Announce_Dialog_FirstBtn_Label: "Andere Postleitzahl",
  ph_menuLocation_Announce_Dialog_PolyMap_Content: "Deine aktuelle Position können wir leider nicht beliefern. Bitte gibt eine andere Adresse an, oder ändere den Bestelltyp.",
  ph_menuLocation_Announce_Dialog_PolyMap_FirstBtn_Label: "Andere Adresse",
  ph_menuLocation_Announce_Dialog_SecondBtn_Label: "Bestelltyp wählen",
  ph_MenuLocation_WebVoucher_Title: "Welcher ist Dein Lieblingsstandort?",
  ph_MenuLocation_WebVoucher_SubTitle: "Selbstverständlich kannst Du unsere Gutscheine in allen Standorten einlösen.",
  ph_menuLocation_Address_Required_Warning_Info: "Leider konnte die genaue Adresse nicht gefunden werden. Die Standorte werden anhand der PLZ angezeigt.",

  ph_orderAddressQuery_ApproximatedAddress_Title: "Wir konnten keine genaue Adresse herausfinden",
  ph_orderAddressQuery_ApproximatedAddress_Content: "Leider konnten wir keine genaue Adresse zu deinen Angaben finden. Du kannst die Adresse korrigieren oder mit der angegebenen Postleitzahl weitermachen.",
  ph_orderAddressQuery_ApproximatedAddress_BtnLabel: "Weiter mit PLZ",
  ph_orderAddressQuery_ApproximatedAddress_Option: "Sollten wir deine genaue Adresse momentan nicht finden können, kannst du trotzdem mit der Postleitzahl weitermachen. Falls wir dich nicht beliefern können, kannst Du Deine Bestellung natürlich auch gerne bei uns abholen. Wähle hierfür bitte den Bestelltyp „Abholung“ aus.",

  phOrderAddressQuery_VerifyAdjusted_Title: "Die eingegebene Adresse konnte nicht eindeutig bestätigt werden. Wir haben folgende Adresse ermittelt:",
  phOrderAddressQuery_UseSuggestion_BtnLabel: "Vorgeschlagene Adresse übernehmen",
  phOrderAddressQuery_Cancel_BtnLabel: "Adresse selbst korrigieren",
  phOrderAddressQuery_KeepMyInput_BtnLabel: "Meine Eingabe verwenden",
  phAddressCompare_YourInput_Label: "Deine Eingabe:",
  phAddressCompare_SuggestedAddress_Label: "Vorgeschlagene Adresse:",
  phUserProfileAddress_VerifyUnavailable_Title: "Adressprüfung derzeit nicht möglich",
  phUserProfileAddress_VerifyUnavailable_Content: "Die Adresse konnte im Moment nicht überprüft werden.Bitte versuche es später erneut.",
  phUserProfileAddress_VerifyUnavailable_BtnLabel: "OK",
  phUserProfileAddress_VerifyInvalid_Title: "Adresse unvollständig oder ungültig",
  phUserProfileAddress_VerifyInvalid_Content: "Die eingegebene Adresse konnte nicht eindeutig bestätigt werden. Bitte überprüfe die Angaben und passe sie an.",

  phOrderResult_ThankYouForYourOrder: "Vielen Dank für Deine Bestellung",
  phOrderResult_ConfirmationMailSend_TEXT: "Wir haben Dir soeben eine Bestellbestätigung per E-Mail an {email} geschickt.",
  phOrderResult_Success_YourOrder: "Deine Bestellung:",
  phOrderResult_SuccessDelivery_BASE_Nostreet: "Deine Bestellung ({orderid}) wird {time} ausgeliefert.",
  phOrderResult_SuccessDelivery_BASE: "Deine Bestellung ({orderid}) wird{day} {time} in der {street} ausgeliefert.",
  phOrderResult_SuccessInHause_BASE: "Deine Bestellung ({orderid}) ist bei uns eingegangen und kommt in kurzer Zeit zu dir an den Tisch!",
  phOrderResult_SuccessPickup_BASE_Nostreet: "Deine Bestellung ({orderid}) ist {time} zur Abholung bereit.",
  phOrderResult_SuccessPickup_BASE: "Deine Bestellung ({orderid}) ist{day} {time} zur Abholung in der {street} bereit.",
  phOrderResult_SuccessDelivery_BASE_Hero_Nostreet: "({orderid}) wird {time} ausgeliefert.",
  phOrderResult_SuccessDelivery_BASE_Hero: "({orderid}) wird{day} {time} in der {street} ausgeliefert.",
  phOrderResult_SuccessPickup_BASE_Hero_Nostreet: "({orderid}) ist {time} zur Abholung bereit.",
  phOrderResult_SuccessPickup_BASE_Hero: "({orderid}) ist{day} {time} zur Abholung in der {street} bereit.",
  phOrderResult_Success_Retail_WillBePackaged_TEXT: "wird umgehend verpackt und in den nächsten Tagen an Dich versandt.",
  phOrderResult_DayAtPrefix: "am",
  phOrderResult_TimeAboutPrefix: "um ca.",
  phOrderResult_AsSoonAsPossible: "Schnellstmöglich",
  phOrderResult_PhoneNumberForCallback: "Telefonnummer für Rückfragen",
  phOrderResult_ToTheHomescreen: "Zum Startbildschirm",
  phOrderResult_YourOrderWasCancelled: "Deine Bestellung wurde leider abgebrochen, bitte versuche es erneut",
  phOrderResult_DoYouWantToContinue_TEXT: "Möchtest Du Deine Bestellung fortsetzen oder eine andere Zahlungsmethode wählen? Dann wähle zurück zum Check-Out.",
  phOrderResult_ReturnToCheckout: "Zurück zum Check-Out",
  phOrderResult_OrderCouldNotBeAccepted: "Deine Bestellung konnte leider nicht angenommen werden",
  phOrderResult_ThereWasAProblem_TEXT: "Anscheinend hat es Probleme bei Deiner Bestellung gegeben, bitte versuche es mit einer anderen Zahlungsmethode.",
  phOrderResult_CollectedPointsForBonus_BASE: "Du hast {points} für die Bonusaktion {bonusaction} gesammelt!",
  phOrderResult_Points: "Punkte",
  phOrderResult_Point: "Punkt",
  phOrderResult_SuccessWebvoucher_DownloadText: "Über die nachfolgenden Links kannst Du Deine Gutscheine herunterladen.",
  phOrderResult_SuccessWebvoucher_ConfirmationMailSend: "Zusätzlich haben wir Dir diese auch per E-Mail an {email} geschickt.",
  phOrderResult_SuccessWebvoucher_ConfirmationPostSend: "Deine Gutscheine senden wir in Kürze an die von Dir angegebene Lieferadresse.",
  phOrderResult_WebVoucherOrderList_header: "Gutschein(e)",
  phOrderResult_SuccessWebvoucher_TitleVoucher: "Gutschein",
  phOrderResult_SuccessWebvoucher_Person_Count: "Personen",
  phOrderResult_SuccessWebvoucher_Person_Post_Delivery: "Postversand",
  phOrderResult_SuccessWebvoucher_Person_Mail_Delivery: "Download",
  phOrderResult_SuccessWebvoucher_TitleAmount: "Betrag",
  phOrderResult_SuccessWebvoucher_TitleLink: "Link zum Gutschein",
  phOrderResult_SuccessWebvoucher_TextLink: "PDF",
  phOrderResult_SuccessWebvoucher_ButtonLink: "Gutschein(e) herunterladen",
  phOrderResult_SuccessTicket_DownloadText: "Über die nachfolgenden Links kannst Du Deine Tickets herunterladen.",
  phOrderResult_SuccessTicket_TitleTicket: "Tickets",
  phOrderResult_SuccessTicket_ButtonLink: "Ticket(s) herunterladen",
  phOrderResult_SuccessTicket_DownloadInfo: "Über die nachfolgenden Links kannst Du Deine Tickets herunterladen.",
  phOrderResult_CloseTab: "Tab schließen",
  phOrderResult_VoucherCredit_Charge: "Wir haben Dein Guthaben um Deinen Wunschbetrag erhöht.",

  phInvalidDeliveryAddress_Title: "Das hat nicht funktioniert",
  phInvalidDeliveryAddress_content: "Diese Adresse kann leider nicht von dem ausgewählten Standort beliefert werden. Bitte wähle eine andere Lieferadresse, oder einen anderen Standort aus. Solltest Du einen anderen Standort auswählen, so wird der Warenkorb bei einem Wechsel entleert.",

  phResetBasketWarning_Title: "Produkte im Warenkorb",
  phResetBasketWarning_SubHeaderContent: "Du hast noch Produkte für Standort {locationName} hinterlegt.",
  phResetBasketWarning_Content: "Möchtest Du mit einer neuen Auswahl starten oder die jetzige Bestellung fortsetzen?",
  phResetBasketWarning_RemainOrder_Button: "Fortsetzen",
  phResetBasketWarning_ResetBasket_Button: "Neue Bestellung",

  phDiscardBasketDialog_Title: "Bestellung wirklich verwerfen?",
  phDiscardBasketDialog_Content: "Möchtest Du Deine Bestellung wirklich verwerfen und auf anderem Wege bei uns bestellen?",
  phDiscardBasketDialog_RemainOrder_Button: "Zurück",
  phDiscardBasketDialog_ResetBasket_Button: "Bestellung verwerfen",

  phWebshopVacationWarning_Button: "Okay",

  phQRCode_Page_Title: "Im Haus Bestellung",
  phQRCode_page_Description: "Bitte scanne den Tischcode um jetzt bei uns zu bestellen.",
  phQRCode_Access_Denied_Text: "Leider können wir nicht auf Deine Kamera zugreifen.<br><br>Bitte kontrolliere gegebenenfalls Deine Handy- oder Browsereinstellungen.",
  phQRCode_PlaceHolder: "5-stelliger Tischcode",
  phQRCode_Page_Button: "Tischcode eingeben",
  phQRCode_ScanFail_Title: "Der QR Code ist nicht lesbar",
  phQRCode_ScanFail_Content: "Leider konnte der QR Code nicht gelesen werden. Gebe den QR Code in die Textfläche ein.",
  phQRCode_ScanFail_Button_Text: "Schließen",
  phQRCodeScanner_NoCamera_HTML: "Keine Kamera? Kein Problem!<br>Einfach den 5-stelligen Tischcode eingeben und sofort bestellen.",

  phQrcode_Brightness_Adgustment_Browser: "Für ein optimales Scanergebnis bitte die Helligkeit anpassen.",

  phQRCode_Manual_Page_Title: "Im Haus Bestellung",
  phQRCode_Manual_Page_Description: "Bitte gib hier Deinen 5-stelligen Tischcode ein.",
  phQRCode_Manual_Page_Button: "Weiter",
  phQRCode_Manual_Validate: "Tischcode ist ungültig",

  phInHouseOrdering_Title: "Bestellung zum Tisch",
  phInHouseOrdering_description: "Bestelle jetzt bequem mit dem Smartphone und erhalte Deine Bestellung in kurzer Zeit direkt an den Tisch.",
  phInHouseOrdering_Button_Text: "Weiter",

  phInHouse_NoQRCode_Warning_Title: "Der Tischcode ist leider nicht gültig",
  phInHouse_NoQRCode_Warning_Description: "Leider ist der von Dir eingegebene Tischcode nicht gültig. Bitte kontrolliere Deine Eingabe oder wende Dich an unseren Service. Wir helfen Dir gerne weiter.",
  phInHouse_NoQRCode_Warning_Button_Text: "Schließen",

  phInHouse_NoLocation_Warning_Title: "Bestelltyp nicht verfügbar",
  phInHouse_NoLocation_Warning_Description: "Der von dir aufgerufene Bestelltyp ist leider nicht verfügbar, bitte wende Dich an unser Servicepersonal.",
  phInHouse_NoLocation_Warning_Button_Text: "Zum Startbildschirm",

  phVoucherCredit_Page_Title: "Gutschein & Guthaben",
  phVoucherCredit_Page_Description: "Möchtest Du Deine Kundenkarte aufladen oder einen neuen Geschenkgutschein bestellen?",
  phVoucherCredit_Credit_Title: "Guthaben aufladen",
  phVoucherCredit_Credit_Description: "Prepaid-Guthaben aufladen und zukünftig bargeldlos bezahlen.",
  phVoucherCredit_Voucher_Title: "Gutschein bestellen",
  phVoucherCredit_Voucher_Description: "Hier Gutscheine bestellen, und gleich per E-Mail erhalten.",
  phVoucherCredit_Warning_Title: "Entschuldigung...",
  phVoucherCredit_Warning_Description: "Leider konnten wir Deine Anfrage nicht verarbeiten. Bitte versuche es später erneut.",

  phNewOrderTimeDialog_Title: "Wie die Zeit vergeht...",
  phNewOrderTimeDialog_Description: "Leider können wir Deine Bestellung nicht mehr zum gewünschten Zeitpunkt ausführen.<br>Bitte wähle eine neue Zeit aus.",
  phNewOrderTimeDialog_Description_Closed: "Leider können wir Deine Bestellung heute nicht mehr annehmen.<br>Komm doch bitte morgen wieder hier vorbei.",
  phNewOrderTimeDialog_Button_NewTime: "Weiter",
  phNewOrderTimeDialog_Button_Close: "Abbrechen",

  phCookie_Cookie: "Cookies",
  phCookieBanner_Title: "Wir verwenden Cookies",
  phCookieBanner_Button_Accept: "Annehmen",
  phCookieBanner_Button_Deny: "Ablehnen",
  phCookieBanner_Button_Accept_All: "Alle Cookies akzeptieren",
  phCookieBanner_Button_Infos: "Datenschutz-Information",

  phCookieBanner_Content: "Wir möchten unseren Service für Sie so nutzerfreundlich wie möglich gestalten. Damit wir unsere Funktionen optimal anbieten können, werden notwendige Cookies eingesetzt. Die Verarbeitung Ihrer personenbezogenen Daten können Sie unserer Datenschutz-Information entnehmen. Den Erhalt und Ihr Verständnis der Datenschutz-Information zum Einsatz von notwendigen Cookies bestätigen Sie durch den nachfolgenden Button.",

  phCookieStatement_Title_First: "Notwendige Verarbeitung von personenbezogenen Daten",
  phCookieStatement_Title_Second: "Notwendige Cookies",

  phCookieStatement_Button_Close: "Schließen",
  phCookieStatement_Table_cookieName: "Cookiename",
  phCookieStatement_Table_URL: "URL",
  phCookieStatement_Table_service: "Service",
  phCookieStatement_Table_validity: "Aufbewahrungsdauer",
  phCookieStatement_Table_country: "Ort der Verarbeitung",
  phCookieStatement_Table_active: "Aktiv",
  phCookieStatement_Table_description: "Zweck der Datenverarbeitung",
  phCookieStatement_Table_company: "Verarbeitendes Unternehmen",
  phCookieStatement_Table_rightTerms: "Rechtliche Grundlage",
  phCookieStatement_Table_technology: "Genutzte Technologien",
  phCookieStatement_Table_dataCollect: "Gesammelte Daten",
  phCookieStatement_Table_dataRecipient: "Datenempfänger",
  phCookieStatement_Table_dataProtectionOfficer: "Datenschutzbeauftragter des verarbeitenden Unternehmens",
  phCookieStatement_Table_dataProcessors: "Klicke hier, um die Datenschutzbestimmungen des Datenverarbeiters zu lesen",

  phLicense_Licenses: "Lizenzen",
  phLicense_License: "Lizenz",
  phLicense_Title: "Verwendete Lizenzen",
  phLicense_Name: "Name",
  phLicense_Version: "Version",
  phLicense_Author: "Autor",
  phLicense_Showmore_Button: "Mehr anzeigen",
  phLicense_Showless_Button: "Weniger anzeigen",
  phLicense_URL: "URL",
  phLicense_Repository_URL: "Repository URL",
  phLicense_Description: "Beschreibung",
  phLicense_Close_Button: "Schließen",

  phOperator_Info_Title: "Informationen zum Betreiber",
  phOperator_Info_Content: "Die Hypersoft Trading GmbH ist für die Inhalte der Bestellseite nicht verantwortlich! Bei Fragen zu Ihrer Bestellung, Produkten/ Menüs, Zusatzstoffe oder Nährwerte, wenden Sie sich bitte direkt an das o.g.Restaurant.",

  phFilterTagDialog_Title: "Vorlieben",
  phFilterTagDialog_Description: "Hier kannst Du Deine Vorlieben hinterlegen und unser Angebot danach sortieren.",
  phFilterTagDialog_Button_Save: "Übernehmen",
  phFilterTagDialog_Button_Close: "Zurücksetzen",
  phFilterTagDialog_Checkbox_Content: "Einstellung für zukünftige Bestellungen merken",

  phA11YDialog_Headline: "Barrierefrei",
  phA11YDialog_Title: "Barrierefreier Modus",
  phA11YDialog_Description: "Der Barrierefreie Modus. Wähle den gewünschten Modus aus, um ihn zu aktivieren.",
  phA11YDialog_Button_FontSize: "Schriftgröße erhöhen",
  phA11YDialog_Button_ColorContrast: "Farbkontrast erhöhen",
  phA11YDialog_Button_HideImages: "Bilder ausblenden",
  phA11YDialog_Button_ReducedMotion: "Reduzierte Animation",
  phA11YDialog_Button_Back: "Zurück",
  phA11YDialog_Button_Confirm: "Bestätigen",
  phA11YDialog_Button_Close: "Zurücksetzen",
  phA11YDialog_Button_MoreInfo: "Weitere Informationen zur Barrierefreiheit",
  phA11Y_image_alt_text: "Abbildung: Veranschaulicht die im Text beschriebenen Informationen.",

  phA11Y_slider: "Slider: Verwenden Sie die Pfeiltasten, um den Wert zu ändern.",
  phA11Y_no_aria: "Achtung: Dieses Element enthält keine ARIA-Attribute und ist möglicherweise nicht barrierefrei.",
  phA11Y_button: "Button: Löst eine Aktion aus.",
  phA11Y_spin_button: "Eingabefeld für Zahlen",
  phA11Y_input: "Eingabefeld: Geben Sie hier Text ein.",
  phA11Y_select: "Auswahlfeld: Öffnen Sie die Liste und wählen Sie eine Option.",
  phA11Y_checkbox: "Kontrollkästchen: Aktivieren oder deaktivieren Sie diese Option.",
  phA11Y_link: "Link: Navigiert zu einer anderen Seite oder einem Abschnitt.",

  phA11Y_open_coupon_detail: "Coupon Details öffnen",

  phA11Y_calendar_day: "{day}. {month} {year}",
  phA11Y_calendar_day_today: "{day}. {month} {year}, Heute",
  phA11Y_calendar_day_selected: "{day}. {month} {year}, Ausgewählt",
  phA11Y_calendar_day_available: "Verfügbar",
  phA11Y_calendar_day_unavailable: "Nicht verfügbar",
  phA11Y_calendar_previous_month: "Vorheriger Monat",
  phA11Y_calendar_next_month: "Nächster Monat",
  phA11Y_calendar_previous_year: "Vorheriges Jahr",
  phA11Y_calendar_next_year: "Nächstes Jahr",
  phA11Y_calendar_select_month: "{month} {year}, Monat wählen",
  phA11Y_calendar_select_year: "{year}, Jahr wählen",
  phA11Y_calendar_year: "Jahr {year} auswählen",

  phFixedBasketErrorPage_PleaseTryAgainLater_Text: "Unser Angebot wird gerade aktualisiert, bitte versuche es in einigen Minuten erneut. Vielen Dank für Dein Verständnis.",
  phFixedBasketErrorPage_NoBasket_Text: "Die Bestellung wurde schon durchgeführt oder der Warenkorb ist veraltet. Bitte führe die Bestellung noch einmal durch. Vielen Dank für Dein Verständnis.",

  phOpenLinkInApp_Text: "Link in App öffnen?",
  phOpenLinkInApp_Action_Open: "Anzeigen",

  phInHouseOrder_CloseOrdering_Button: "Tisch verlassen",

  phServiceCall_Title: "Serviceruf",
  phServiceCall_Description: "Wie können wir Dir weiterhelfen?",
  phServiceCall_SecureCheckDialog_Title: "Möchtest Du den Serviceruf jetzt übermitteln?",
  phServiceCall_SecureCheckDialog_AcceptBtn_Label: "Bestätigen",
  phServiceCall_SecureCheckDialog_DenyBtn_Label: "Abbrechen",
  phServiceCall_Success_Title: "Der Serviceruf wurde erfolgreich übermittelt, wir werden uns schnellstmöglich um Dein Anliegen kümmern.",
  phServiceCall_Fail_Title: "Serviceruf fehlgeschlagen!",
  phServiceCall_Button: "Ok",

  phInHouseService_Ordered_Items: "Bestellte Artikel",
  phInHouseService_Open_Bill: "Offene Rechnung",
  phInHouseService_NoOrderYet_Title: "Keine Artikel zur Zahlung vorhanden",
  phInHouseService_NoOrderYet_Description: "Es sind noch keine Artikel auf diesem Tisch zur Zahlung vorhanden. Bitte tätige erst eine Bestellung, um diese Funktion nutzen zu können.",
  phInHouseService_Button_Text: "Du bist eingeloggt auf",
  phInHouseService_Table: "Tisch {table_no}",
  phInHouseService_Group: "Bestellgruppe {group}",
  phInHouseService_Guest: "Gast {seat_no}",
  phInHouseService_Items: "{items_count} Artikel",
  phInHauseService_Leave_Table_Dialog_Title: "Möchtest Du den Tisch wirklich verlassen?",
  phInHauseService_Leave_Table_Content: "Es sind noch nicht alle Artikel bezahlt oder es befinden sich noch nicht bestellte Artikel im Warenkorb. Möchtest Du den Tisch wirklich verlassen?",
  phInHauseService_Leave_Table_Dialog_Button: "Tisch verlassen",

  phInHouseOrderResult_ThankYouForYourVisit: "Vielen Dank für Deinen Besuch",
  phInHouseOrderResult_SuccessfullPayment: "Vielen Dank für Deinen Besuch, wir haben Deine Zahlung erhalten.",
  phInHouseOrderResult_SuccessfullPayment_SecondParagraph: "Wir würden uns freuen, Dich bald wieder bei uns begrüßen zu dürfen.",
  phInHouseOrderResult_OpenItems: "Auf Deinem Tisch befinden sich noch {items} unbezahlte Artikel, mit einer Summe von {total} EUR.",
  phInHouseOrderResult_ToNoCOO: "Zur Rechnung",
  phInHouseOrderResult_ToTable: "Zur Tischübersicht",
  phInHouseOrderResult_ToTheHomescreen: "Zum Startbildschirm",
  phInHouseOrderResult_YourPaymentWasCancelled: "Deine Bezahlung wurde leider abgebrochen, bitte versuche es erneut",
  phInHouseOrderResult_DoYouWantToContinue_TEXT: "Möchtest Du eine andere Zahlungsmethode wählen? Dann wähle zurück zum Check-Out.",
  phInHouseOrderResult_PaymentCouldNotBeAccepted: "Deine Bezahlung konnte leider nicht angenommen werden",
  phInHouseOrderResult_ThereWasAProblem_TEXT: "Anscheinend hat es Probleme bei Deiner Bezahlung gegeben, bitte versuche es mit einer anderen Zahlungsmethode.",
  phInHouseOrderResult_FailedPaymentDialog_Title: "Zahlung fehlgeschlagen",
  phInHouseOrderResult_FailedPaymentDialog_Text: "Deine Zahlung ist leider fehlgeschlagen, bitte versuche es erneut, oder wende Dich an unser Servicepersonal.",
  phInHouseOrderResult_FailedPaymentDialog_Button: "Abbrechen ",
  phInHouseOrderResult_Mandatory_Payment_Header: "Vielen Dank für Deine Bestellung",
  phInHouseOrderResult_Mandatory_Payment_Info: "Deine Bestellung auf Tischnummer {table_no} ist bei uns eingegangen.",
  phInHouseOrderResult_Mandatory_Payment_PayAtWaiter: "Bitte bezahle jetzt Deine Bestellung an der Kasse, indem du den QR-Code vorzeigst. Nach der vollständigen Zahlung wird Deine Bestellung abgeschlossen.",
  phInHouseOrderResult_AnnounceDialog_PayAtWaiter_Title: "Zahlung ausstehend",
  phInHouseOrderResult_AnnounceDialog_PayAtWaiter_Content: "Die Zahlung an der Kasse ist ausstehend. Du benötigts den QR-Code, um die Bestellung abzuschließen. Hast Du bereits gezahlt und möchtest zum Startbildschirm?",
  phInHouseOrderResult_AnnounceDialog_PayAtWaiter_StayBtn: "Zurück",
  phInHouseTableClose_Title: "Tisch schließen",
  phInHouseTableClose_Content: "Du möchtest den Tisch abschließen. Falls andere Personen noch nicht bestellt haben, werden sie abgemeldet und der Tisch wird geschlossen.",
  phInHouseTableClose_Btn_Confirm: "Bezahlung fortsetzen",
  phInHouseTableClose_Btn_Cancel: "Abbrechen",

  phAgeDialog_Title: "Altersfreigabe erst ab {age} Jahren!",
  phAgeDialog_Note: "Hiermit bestätigst Du, dass Du mindestens das oben genannte Alter erreicht hast und berechtigt bist, diesen Artikel zu bestellen.",
  phAgeDialog_Confirm_Btn: "Ja, ich habe das oben genannte Alter erreicht.",
  phAgeDialog_Deny_Btn: "Nein, ich habe das oben genannte Alter noch nicht erreicht.",
  phAgeDialog_Notice: "Wir behalten uns vor, eine Alterskontrolle durchzuführen.",

  phLocation_Required_Dialog_Title: "Standortbestimmung erforderlich",
  phLocation_Required_Dialog_Sub_Text: "Bitte aktiviere die Standortbestimmung Deines Handys, um mit der Bestellung fortzufahren.",
  phLocation_Dialog_Distance_Title: "Bist Du nicht in unserem Restaurant?",
  phLocation_Dialog_Distance_Sub_Text: "Du scheinst Dich nicht an unserem Standort zu befinden, bitte verwende einen anderen Bestelltyp.",
  phLocation_Required_Dialog_Button: "Schließen",

  phInHouse_Payment_Select_Btn: "Auswählen",
  phInHouse_Payment_Select_All: "Alle auswählen",
  phInHouse_Payment_Select_Own_Items: "Meine eigenen auswählen",
  phInHouse_Payment_Select_None: "Alle abwählen",
  phPayment_Tab_Order_Overview: "Bestellübersicht",
  phPayment_Tab_Order_Data: "Kundendaten",
  phPayment_Tab_Order_Pay: "Bezahlung",
  phInHouse_Payment_User_Place: "Platz {placeNo}",
  phInHouse_Payment_Table: "Tisch",

  phInHouseLocalBasket_Table_Number: "Tisch:",
  phInHouseLocalBasket_Guest_Label: "Gast",
  phInHouseLocalBasket_User_Place: "Platz {placeNo}",
  phInHouseLocalBasket_Order_Overview: "Tischübersicht",
  phInHouseLocalBasket_Order_List_total: "Gesamt",
  phInHouseLocalBasket_Ordered_Just_Now: "Gerade eben",
  phInHouseLocalBasket_Ordered_At: "vor {min} Minuten",
  phInHouseLocalBasket_ImpressumDialog: "Impressum",
  phInHouseLocalBasket_ImpressumDialog_stnr: "St.Nr.:",
  phInHouseLocalBasket_ImpressumDialog_ustid: "USt-IdNr:",
  phInHouseLocalBasket_ImpressumDialog_commercial_register: "Handelsregister:",
  phInHouseLocalBasket_ImpressumDialog_commercial_telephone: "Telefon:",
  phInHouseLocalBasket_ImpressumDialog_local_court: "Amtsgericht:",
  phInHouseLocalBasket_ImpressumDialog_representative: "Vertretungsberechtigte Person:",

  phInHouse_Sort_Option_Added: "Bestellzeitpunkt",
  phInHouse_Sort_Option_Menucourse: "Menügang",
  phInHouse_Sort_Option_Name: "Artikelbezeichnung",
  phInHouse_Sort_Option_Price_Ascending: "Preis (aufsteigend)",
  phInHouse_Sort_Option_Price_Descending: "Preis (absteigend)",
  phInHouse_Sort_Option_Place: "Platz",

  phInHouse_Payment_Header: "Bestellübersicht",
  phInHouse_Payment_SubText: "Tisch {tableNr}",
  phInHouse_Payment_No_Assignment: "Ohne Zuordnung",

  phInHouse_Continue_Btn: "Weiter",
  phInHouse_Order_Confirm_HTML: "Deine Bestellung auf Tischnummer {table_no} ist bei uns eingegangen und wird in Kürze zubereitet.",

  phInHouse_Item_Not_Avaliable_Header: "Artikel wird bereits bezahlt",
  phInHouse_Item_Not_Avaliable_Subtext: "Dieser Artikel wird bereits bezahlt und kann nicht erneut ausgewählt werden.",
  phInHouse_Item_Not_Avaliable_Btn: "Schließen",

  phInHouse_NoConnection_Title: "Keine Verbindung zum Restaurant",
  phInHouse_NoConnection_Description: "Aufgrund eines technischen Problems, konnte leider keine Verbindung zum Restaurant hergestellt werden. Bitte versuche es später erneut.",
  phInHouse_LostConnection_Title: "Verbindung zum Restaurant verloren",
  phInHouse_LostConnection_Description: "Die Verbindung zum Restaurant wurde leider unterbrochen. Bitte scanne den Tischcode erneut.",
  phInHouse_TableClosed_Title: "Der Tisch wurde geschlossen",
  phInHouse_TableClosed_Description: "Dein Tisch ist bereits bezahlt und wurde geschlossen. Scanne bitte einen Tischcode, wenn Du eine neue Bestellung aufgeben möchtest.",
  phInHouse_Cancel_Btn: "Abbrechen",
  phInHouse_Accept_Btn: "Bestätigen",

  phInHouse_Still_There_Title: "Bist Du noch da?",
  phInHouse_Still_There_Description: "Wir haben Deine Artikelauswahl wegen Inaktivität zurückgesetzt, bitte wiederhole Deinen Zahlungsvorgang.",

  phInHouse_ItemsInBasket_Title: "Du hast noch Artikel in Deinem Warenkorb",
  phInHouse_ItemsInBasket_Description: "Du hast noch nicht bestellte Artikel in Deinem Warenkorb, möchtest Du diese verwerfen und jetzt bezahlen?",

  phInHouse_Reconnect_Dialog_Title: "Verbindung unterbrochen",
  phInHouse_Reconnect_Dialog_Info: "Die Internet Verbindung wurde unterbrochen",
  phInHouse_Reconnect_Dialog_Info_Reconnect: "Wir versuchen neu zu verbinden",

  phInHouse_Discount_Title: "Kein Rabatt möglich",
  phInHouse_Discount_Info: "Dein hinterlegter Rabatt kann in diesem Bestelltyp leider nicht verwendet werden. Bitte wende Dich an unser Servicepersonal.",
  phInHouse_Voucher_Info: "Der auf Deinem Gutschein hinterlegte Rabatt kann in diesem Bestelltyp leider nicht verwendet werden. Bitte tätige die Zahlung bei unserem Servicepersonal, um Deinen Rabatt zu erhalten.",

  phInHouse_Table_Overview_Empty_Title: "Es sind noch keine Bestellungen vorhanden",
  phInHouse_Table_Overview_Empty_Desc: "Sobald etwas auf diesen Tisch bestellt wurde, kannst Du hier die Tischübersicht einsehen.",

  phContinueShoppingDialog_Label: "Artikel in den Warenkorb gelegt",
  phContinueShoppingDialog_Button_Continue: "Weiter bestellen",
  phContinueShoppingDialog_Button_End: "Zum Warenkorb",

  phGroupOrder_Forward_Btn: "Weiter",
  phInHouse_UseName_Request_Title: "Bitte nenne uns Deinen Namen",
  phInHouse_UseName_Request_Desc: "Bitte nenne uns Deinen Namen, damit wir Deine Tischbestellungen besser zuordnen können",
  phInHouse_UseName_Request_InputPh: "Bitte gib Deine Namen ein",

  phContinueShoppingDialog_Label_IHGroup: "Bestelloptionen auswählen",
  phContinueShoppingDialog_Button_IHGroup_AddToGroupBasket: "Zum Gruppenwarenkorb hinzufügen",
  phContinueShoppingDialog_Button_IHGroup_orderDirectly: "Sofort bestellen",
  phContinueShoppingDialog_Button_IHGroup_Overview: "Zur Gruppenübersicht",

  phNotification_Dialog_Title: "Benachrichtigung",
  phNotification_Dialog_Content: "Wir benachrichtigen Dich über Deinen Browser, wenn Deine Bestellung zur Abholung bereitsteht.",
  phNotification_Dialog_DiscardContent: "Sollten wir Dich nicht beachrichtigen dürfen, so kannst Du hier Deine Bestellung verwerfen",
  phNotification_Dialog_DiscardContent_IHGroup: "Sollten wir Dich nicht benachrichtigen dürfen, so kannst Du hier Deine Bestellung abbrechen.",
  phNotification_Dialog_Annotation: "* Bitte auch die Meldung von Deinem Browser oder Betriebssystem bestätigen.",
  phNotification_Dialog_AcceptButton: "Ja, gerne",
  phNotification_Dialog_DiscardTitle: "Keine Benachrichtigung",
  phNotification_Dialog_DiscardButton: "Bestellung verwerfen",
  phNotification_Dialog_DiscardButton_IHGroup: "Bestellung abbrechen",

  phNotificateVieSMS_Dialog_Title: "Entschuldigung, das hat leider nicht geklappt.",
  phNotificateVieSMS_Content: "Leider hat die Aktivierung der Benachrichtigung nicht funktioniert.",
  phNotificateVieSMS_RequestContent: "Bitte trage Deine Handynummer ein, damit wir Dir eine SMS schicken können, wenn Deine Bestellung zur Abholung bereitsteht.",
  phNotificateVieSMS_AcceptButton: "Per SMS benachrichtigen",
  phNotificateVieSMS_Annotation: "*Deine Handynummer wird ausschließlich für diese Benachrichtigung genutzt und im Anschluss wieder gelöscht.",

  phInHouse_WrongCode_Title: "Falscher Tischcode",
  phInHouse_WrongCode_Description: "Du hast leider keinen Tischcode gescannt, bitte versuche es erneut oder wende Dich an unser Servicepersonal.",
  phInHouse_WrongCode_Button: "Zurück",

  phInHouse_No_Notification: "Du hast noch keine Benachrichtigungen aktiviert.",
  phInHouse_Push_Notification: "Wir benachrichtigen Dich, sobald Deine Bestellung zur Abholung bereitsteht",
  phInHouse_SMS_Notification: "Wir senden Dir eine SMS an {phoneNumber} wenn Deine Bestellung zur Abholung bereitsteht",
  phInHouse_SMS_Notification_Change_Number: "Nummer ändern",

  phGroupOrder_WrongCode_Title: "Falscher Gruppencode",
  phGroupOrder_WrongCode_Description: "Du hast leider keinen Gruppencode gescannt, bitte versuche es erneut. Der Gruppencode wird allen Gruppenteilnehmern über die Funktion „Freunde einladen“ angezeigt.",
  phGroupOrder_WrongCode_Button: "Zurück",

  phGroupOrder_OrderNowDialog_Title: "Sofort bestellen",
  phGroupOrder_OrderNowDialog_Content: "Möchtest Du Deine Bestellung wirklch sofort absenden und nicht zusammen mit Deinen Freunden bestellen?",
  phGroupOrder_OrderNowDialog_AcceptButton: "Sofort bestellen",
  phGroupOrder_OrderNowDialog_DenyButton: "Abbrechen",

  phGroupOrder_SendOrderDialog_Title: "Gruppenbestellung absenden?",
  phGroupOrder_SendOrderDialog_Description: "Bist Du sicher, dass Du die Gruppenbestellung für alle Gruppenteilnehmer jetzt aufgeben möchtest?",
  phGroupOrder_SendOrderDialog_AcceptBtn: "Ja, jetzt bestellen",
  phGroupOrder_SendOrderDialog_DenyBtn: "Nein, zurück zur Gruppenansicht",

  phBasketPay_OptionDialog_Title: "Wie möchtest du zahlen?",
  phBasketPay_OptionDialog_Description: "Bitte wähle aus, ob Du an der Kasse, oder digital per Handy bezahlen möchtest.",
  phBasketPay_OptionDialog_PayWaiterBtn: "An der Kasse bezahlen",
  phBasketPay_OptionDialog_PayOnlineBtn: "Digital am Handy bezahlen",
  phBasketPay_WaiterDialog_Title: "An der Kasse bezahlen",
  phBasketPay_OptionDialog_Back_Btn: "zurück zum Tisch",
  phBasketPay_WaiterDialog_Description: "Vielen Dank für Deine Auswahl, bitte zahle direkt an der Kasse.",
  phBasketPay_ErrorDialog_Title: "Entschuldigung, leider ist ein Fehler aufgetreten",
  phBasketPay_ErrorDialog_Description: "Leider konnten wir Deine Zahlungsanfrage nicht verarbeiten.<br>Bitte versuche es später erneut.",
  phBasketPay_ErrorDialog_Dialog_Button: "Zurück",

  phGroupOrder_Landingpage_Title: "Bestellgruppe {groupname}",
  phGroupOrder_Landingpage_Creator: "von {creator}",
  phGroupOrder_Landingpage_BasketTitle: "Aktueller Gruppenwarenkorb",
  phGroupOrder_Landingpage_EmptyBasketContent: "Keine Artikel ausgewählt",
  phGroupOrder_Landingpage_BasketContent: "Artikel im Wert von",
  phGroupOrder_Landingpage_SendGroupOrder_Btn: "Gruppenbestellung absenden",
  phGroupOrder_Landingpage_LeaveGroupOrder_Btn: "Gruppe verlassen",

  phGroupOrder_NoOrderYet_Description: "Es sind noch keine Artikel in dieser Bestellgruppe zur Zahlung vorhanden. Bitte tätige erst eine Bestellung, um diese Funktion nutzen zu können.",

  phGroupOrder_LeaveTable_Dialog_Title: "Möchtest Du die Bestellgruppe wirklich verlassen?",
  phGroupOrder_LeaveTable_Dialog_Content: "Es sind noch nicht alle Artikel bezahlt oder es befinden sich noch nicht bestellte Artikel im Gruppenwarenkorb. Möchtest Du die Bestellgruppe wirklich verlassen?",
  phGroupOrder_LeaveTable_Dialog_Button: "Gruppe verlassen",

  phGroupOrder_Button_Text: "Du bist Mitglied der Bestellgruppe",

  phGroupOrder_Continue_Btn: "Weiter",
  phGroupOrder_Continue_to_Basket_Btn: "Bestellen",
  phGroupOrder_Create_GroupNameInput_PlaceHolder: "Neuer Gruppenname",
  phGroupOrder_Input_Validate_Length: "Bitte gib mindestens 3 Buchstaben ein",
  phGroupOrder_Input_Validate_Forbbiden: "Unzulässiger Gruppenname",
  phGroupOrder_Input_Validate_Empty: "Der Gruppenname darf nicht leer sein",
  phGroupOrder_Input_Validate_Characters: "Bitte keine Sonderzeichen verwenden",
  phGroupOrder_Input_Validate_Name: "Der Name darf nicht leer sein.",
  phGroupOrder_Input_Validate_Forbbiden_UserName: "Unzulässiger Name",

  phGroupOrder_CreateGroup_Header: "Neue Gruppenbestellung erstellen",
  phGroupOrder_CreateGroup_Subtext: "Bitte wähle einen Namen für Deine Gruppe aus",
  phGroupOrder_CreateGroup_Input_Info: "... oder gib einen eigenen Gruppennamen an",
  phGroupOrder_CreateGroup_JoinGroup_Info: "... oder tritt einer bestehenden Bestellgruppe bei",
  phGroupOrder_CreateGroup_JoinGroup_Header: "Beitreten",
  phGroupOrder_CreateGroup_JoinGroup_Desc: "hier kannst Du einer bestehenden Bestellgruppe beitreten",
  phGroupOrder_CreateGroup_Failed_Title: "Erstellung der Bestellgruppe fehlgeschlagen",
  phGroupOrder_CreateGroup_Failed_SubText: "Leider kam es zu einem Fehler bei der Erstellung Deiner Bestellgruppe, bitte versuche es in einigen Minuten erneut.",
  phGroupOrder_CreateGroup_GroupName_Failed_Title: "Gruppenname bereits in Benutzung",
  phGroupOrder_CreateGroup_UserName_Failed_Title: "Benutzername bereits in Benutzung",
  phGroupOrder_CreateGroup_Name_Failed_SubText: "Der eingegebene Name ist leider bereits in Benutzung, bitte verwende einen anderen Namen.",
  phGroupOrder_CreateGroup_Create: "Gruppe erstellen",
  phGroupOrder_CreateGroup_Join_Btn: "Beitreten",

  phGroupOrder_GroupCreated_Header: "Bestellgruppe erfolgreich erstellt!",
  phGroupOrder_GroupCreated_Info: "Du hast die Gruppe {groupName} erfolgreich erstellt.",
  phGroupOrder_GroupCreated_State_Info: "Über das Gruppensymbol in der Titelleiste kannst Du jederzeit den Status Deiner Gruppe einsehen.",
  phGroupOrder_GroupCreated_UserName_Input_Info: "Bitte gib Deinen Namen ein, damit wir Deine Bestellung richtig zuordnen können.",
  phGroupOrder_GroupCreated_UserName_Input_placeholder: "Dein Name",
  phGroupOrder_GroupCreated_Invite_Friends_Info: "Lade Deine Freunde in diese Bestellgruppe ein, um eine gemeinsame Bestellung aufgeben und Euer Essen gemeinsame genießen zu können",
  phGroupOrder_GroupCreated_Invite_Btn: "Jetzt einladen",
  phGroupOrder_GroupCreated_Without_Invite_Btn: "Weiter ohne einladen",

  phGroupOrder_GroupMaxCount_Dialog_Title: "Leider konnte keine Bestellgruppe erstellt werden.",
  phGroupOrder_GroupMaxCount_Dialog_SubText: "Leider wurde bereits die maximale Anzahl an Bestellgruppe für diesen Tisch erreicht. Bitte verwende einen anderen Tischcode oder tätige eine Einzelbestellung.",

  phGroupOrder_InviteFriends_Dialog_Title: "Möchtest Du keine Freunde einladen?",
  phGroupOrder_InviteFriends_Dialog_SubText: "Möchtest Du jetzt wirklich bestellen, ohne vorher Deine Freunde einzuladen?  Mit einer Gruppenbestellung bekommt Ihr Eurer Essen gleichzeitig und könnt gemeinsam genießen.",
  phGroupOrder_InviteFriends_Dialog_OrderBtn: "Bestellen",
  phGroupOrder_InviteFriends_Dialog_OrderNowBtn: "Jetzt Bestellen",
  phGroupOrder_InviteFriends_Dialog_InviteBtn: "Freunde einladen",

  phGroupOrder_LinkExpired_Title: "Die Gruppe ist leider abgelaufen",
  phGroupOrder_LinkExpired_SubText: "Diese Bestellgruppe ist leider abgelaufen, bitte erstelle eine neue Gruppe oder tätige eine Einzelbestellung.",
  phGroupOrder_LinkExpired_Btn: "Neue Bestellung",

  phGroupOrder_Share_Title: "Freunde einladen",
  phGroupOrder_Share_SubText: "Lade Deine Freunde in diese Gruppe ein, um eine gemeinsame Bestellung aufgeben und gemeinsam genießen zu können",
  phGroupOrder_Share_Link_Info: "Sende Deinen Freunden einen Link per Whatsapp & Co",
  phGroupOrder_Share_Link_Btn: "Link teilen",
  phGroupOrder_Share_Link_NotAvailable_Title: "Teilen fehlgeschlagen",
  phGroupOrder_Share_Link_NotAvailable_Subtext: "Leider scheint das Teilen auf Deinem Endgerät nicht zu funktionieren. Über die Schaltfläche „Link kopieren“ kannst Du die Einladung dennoch an Deine Freunde senden, indem Du den Link in Whatsapp & Co einfügst und versendest.",
  phGroupOrder_Share_Link_Copy_Btn: "Link kopieren",

  phGroupOrder_Invite_QRCode_Title: "Per QR-Code",
  phGroupOrder_Invite_QRCode_Info: "Lass Deine Freunde den folgenden Gruppencode scannen, um sie der Bestellgruppe beitreten zu lassen",
  phGroupOrder_Invite_Btn: "QR-Code scannen",

  phGroupOrder_Invitation_Recieved_Title: "Willkommen in der Bestellgruppe {groupName} von {userName}",
  phGroupOrder_Invitation_Recieved_SubText: "Bitte gib Deinen Vornamen ein, damit wir Deine Bestellung richtig zuordnen können. ",
  phGroupOrder_Invitation_Recieved_input: "Bitte gib Deinen Namen ein",
  phGroupOrder_Invitation_Recieved_Join_Btn: "Beitreten",
  phGroupOrder_Invitation_Recieved_Deny_Btn: "Ablehnen",

  phGroupOrder_QRCode_Scanner_Title: "Einer Bestellgruppe beitreten",
  phGroupOrder_QRCode_Scanner_SubText: "Bitte scanne einen Gruppencode, um einer Bestellgruppe Deiner Freunde beizutreten. Der Gruppencode wird allen Gruppenteilnehmern über die Funktion „Freunde einladen“ angezeigt.",
  phGroupOrder_QRCode_Scanner_NoCam_Info: "Solltest Du keine Kamera haben und den Gruppencode nicht scannen können, so bitte Deine Freunde um eine Gruppeneinladung per Link zu teilen",

  phGroupOrder_MaxMemberCount_Title: "Kein Beitritt möglich",
  phGroupOrder_MaxMemberCount_SubText: "Leider ist kein Beitritt mehr möglich, da die maximale Gruppengröße bereits erreicht wurde. Bitte erstelle eine neue Bestellgruppe oder tätige eine Einzelbestellung.",

  phGroupOrder_LocationClosed_Title: "Kein Beitritt möglich",
  phGroupOrder_LocationClosed_SubText: "Leider ist kein Beitritt mehr möglich, wie es aussieht haben wir gerade geschlossen. Bitte beachte unsere Öffnungszeiten.",

  phGroupOrder_GroupOverview_Title: "Bestellgruppe {groupName} von {groupCreatorName}",
  phGroupOrder_GroupOverview_UserList_Basket: "Im Warenkorb",
  phGroupOrder_GroupOverview_UserList_Ordered: "Bestellt",
  phGroupOrder_GroupOverview_Basket_Title: "Aktueller Gruppenwarenkorb",
  phGroupOrder_GroupOverview_Basket_Info: "Artikel im Wert von",
  phGroupOrder_GroupOverview_Basket_NoOrder_Title: "Keine Artikel ausgewählt",
  phGroupOrder_GroupOverview_Basket_PlaceGroupOrder_Btn: "Gruppenbestellung absenden",

  phGroupOrder_MemberOrder_Detail_Label: "Bestellübersicht von",
  phGroupOrder_MemberOrder_Detail_Basket_Label: "Artikel im Gruppenwarenkorb",
  phGroupOrder_MemberOrder_Detail_Ordered_Label: "Bestellte Artikel",
  phGroupOrder_MemberOrder_Detail_ApplyChange_Btn: "Änderung übernehmen",
  phGroupOrder_MemberOrder_Detail_PayNow_Btn: "Jetzt bezahlen",
  phGroupOrder_MemberOrder_Detail_Total_Label: "Gesamtsumme",
  phGroupOrder_MemberOrder_Detail_Empty_Basket: "Keine Artikel im Gruppenwarenkorb",
  phGroupOrder_MemberOrder_Detail_Empty_Order: "Keine Bestellungen vorhanden",
  phGroupOrder_MemberOrder_Detail_OrderNow_Btn: "Jetzt bestellen",
  phGroupOrder_MemberOrder_Detail_State_Preparation: "in Zubereitung",
  phGroupOrder_MemberOrder_Detail_State_Pickup: "Abholbereit",
  phGroupOrder_MemberOrder_Detail_State_PickedUp: "abgeholt",

  phGroupOrder_Payment_Group: "Bestellgruppe",

  phGroupOrder_Confirm_HTML: "Deine Bestellung für Bestellgruppe {group_name} ist bei uns eingegangen und wird in Kürze zubereitet.",
  phGroupOrder_PaymentResult_GroupBtn: "Zur Gruppenübersicht",

  phGroupOrder_UserIsAlready_Member_Title: "Kein Beitritt möglich",
  phGroupOrder_UserIsAlready_Member_SubText: "Du bist bereits Mitglied einer Bestellgruppe. Bitte gehe auf „Bestellgruppe verlassen“, bevor Du einer anderen Bestellgruppe beitreten kannst.",

  phPhoneInput_Min_Error: "Bitte mindestens 6 Ziffern eingeben.",
  phPhoneInput_Max_Error: "Bitte maximal 16 Ziffern eingeben.",
  phPhoneInput_NumbersOnly_Error: "Bitte nur Ziffern eintragen.",

  phChangePhoneNumber_Title: "Rufnummer bearbeiten",
  phChangePhoneNumber_SubText: "Hier kannst Du Deine für die Notification hinterlegte Rufnummer {phoneNumber} anpassen. Bitte beachte, dass bereits zugestellte Notifications nicht noch einmal verschickt werden.",
  phChangePhoneNumber_Btn_Label: "Übernehmen",

  phChangePhoneNumber_Failed_Title: "Entschuldigung, leider ist ein Fehler aufgetreten",
  phChangePhoneNumber_Failed_Desc: "Leider konnten wir die Änderung Deiner Rufnumer nicht verarbeiten, bitte versuche es in einigen Minuten erneut.",

  phCoupon_Redeem_Title: "Coupons einlösen",
  phCoupon_Redeem_Description: "Hier kannst Du unsere Coupons direkt im Webshop einlösen.",
  phCoupon_Redeem_AppCoupon_Title: "Coupon auswählen",
  phCoupon_Redeem_Show_All: "Alle anzeigen",
  phCoupon_Redeem_Btn_Label: "Coupon einlösen",
  phCoupon_Redeem_Scan_Title: "Couponcode scannen",
  phCoupon_Redeem_Scan_Btn_Text: "Jetzt scannen",
  phCoupon_Redeem_Scan_Btn_Text_Cancel: "Abbrechen",
  phCoupon_Redeem_Input_Title: "Couponcode eingeben",
  phCoupon_Redeem_Input_Placeholder: "{requiredLength}- stelliger Couponcode",
  phCoupon_Redeem_Error_MinLength: "Bitte mindestens {requiredLength} Ziffern eingeben.",
  phCoupon_Redeem_Error_MaxLength: "Bitte maximal {requiredLength} Ziffern eingeben.",
  phCoupon_Redeem_Error_NumbersOnly: "Bitte nur Ziffern eintragen.",
  phCoupon_Redeem_OrderType_Not_Valid_Title: "Bestelltyp ungültig",
  phCoupon_Redeem_OrderType_Not_Valid_SubText: "Für Deine ausgewählte Bestelltyp können leider keine Coupons eingelöst werden, bitte wähle einen andere Bestelltyp aus.",
  phCoupon_Redeem_OrderType_Not_Valid_Change_Btn: "Bestelltyp wechseln",
  phCoupon_Redeem_OrderType_Not_Valid_Cancel_Btn: "Abbrechen",
  phCoupon_Redeem_Code_Not_Valid_Title: "Coupon ungültig",
  phCoupon_Redeem_Code_Not_Valid_SubText: "Der Couponcode ist leider ungültig, oder am ausgewählten Standort nicht verfügbar. Bitte verwende einen anderen Couponcode.",
  phCoupon_Redeem_Cannt_Redeem_Code_SubText: "Der Couponcode ist leider ungültig. Bitte verwende einen anderen Couponcode.",
  phCoupon_Redeem_Product_Not_Available_Title: "Coupons nicht einlösbar ",
  phCoupon_Redeem_Product_Not_Available_SubText: "Der Couponcode ist leider aktuell nicht einlösbar. Bitte versuche es morgen erneut.",
  phCoupon_Redeem_LocationAndOrderType_Dialog_Title: "Wo möchtest Du Deinen Coupon einlösen?",
  phCoupon_Redeem_LocationAndOrderType_Dialog_Tab_location_Label: "Standorte",
  phCoupon_Redeem_LocationAndOrderType_Dialog_Tab_Location_Desc: "Bitte wähle einen Standort zur Einlösung Deines Coupons aus.",
  phCoupon_Redeem_LocationAndOrderType_Dialog_Tab_OrderType_label: "Bestelltyp",
  phCoupon_Redeem_LocationAndOrderType_Dialog_Tab_OrderType_Desc: "Wie möchtest Du den Coupon bei uns einlösen?",
  phCoupon_Redeem_LocationAndOrderType_Dialog_Tab_OrderType_Empty: "Leider kann der ausgewählte Coupon an diesem Standort nicht eingelöst werden. Bitte versuche es mit einem anderen Coupon.",
  phCoupon_Redeem_Table_Login_Required_Dialog_Title: "Tischcode benötigt",
  phCoupon_Redeem_Table_Login_Required_Dialog_Desc: "Bitte scanne zuerst einen Tischcode, bevor Du den Coupon einlösen kannst. ",
  phCoupon_Redeem_NoLocation_Dialog_Title: "Entschuldigung",
  phCoupon_Redeem_NoLocation_Dialog_Descr: "Leider kann der ausgewählte Coupon nicht eingelöst werden. Bitte versuche es mit einem anderen Coupon.",
  phCoupon_State_AlreadyRedeemed: "Bereits eingelöst",
  phCoupon_State_InCart: "Im Warenkorb",
  phCoupon_Redeem_Error_AlreadyRedeemed: "Dieser Coupon wurde bereits eingelöst und kann nicht erneut verwendet werden.",
  phCoupon_Redeem_Error_AlreadyRedeemed_Title: "Coupon bereits eingelöst",
  phCoupon_InCart_Dialog_Title: "Coupon bereits im Warenkorb",
  phCoupon_InCart_Dialog_Text: "Dieser Coupon wurde bereits hinzugefügt und wird beim Abschluss deiner Bestellung automatisch eingelöst. Er kann nur einmal eingelöst werden.",
  phCoupon_InCart_Dialog_ToCart: "Zum Warenkorb",
  phCoupon_InCart_Dialog_Back: "Zurück",
  phCoupon_BasketLine_Label: "Coupon",

  phUpdate_App_Optionally_Dialog_Header: "Update verfügbar",
  phUpdate_App_Optionally_Dialog_Description: "Die neue Version {versionsNummer} ist im Shop verfügbar",
  phUpdate_App_Optionally_Dialog_Btn_Update: "Aktualisieren",

  phUpdate_App_Forced_Dialog_Header: "Update erforderlich",
  phUpdate_App_Forced_Dialog_Description: "Bitte aktualisiere auf die Version {versionsNummer} um unsere App weiter nutzen zu können",
  phUpdate_App_Forced_Dialog_Btn_Update: "Aktualisieren",

  phTimeCotrolDialog_Info_Items: "Produkte außerhalb der Bestellzeit",
  phTimeCotrolDialog_Description: "Ein oder mehrere Produkte können leider nicht für die ausgewählte Zeit bestellt werden. Bitte berücksichtige die jeweils angegebenen Bestellzeiten.",
  phTimeCotrolDialog_Scheduled_info_Order_Time: "Bestellzeit bis:",
  phTimeCotrolDialog_Scheduled_info_AnotherDay_Order_Time: "Bestellzeit {fromTime} - {toTime} Uhr",
  phTimeCotrolDialog_No_Order_Possible_For_Selected_Time: "Bestellung um {time} Uhr nicht möglich",
  phTimeCotrolDialog_No_Order_Possible_For_Selected_Day: "Bestellung am ausgewählten Tag nicht möglich",
  phTimeCotrolDialog_Button_Remove_item: "Produkte entfernen",
  phTimeCotrolDialog_Button_Change_Time: "Bestellzeit ändern",

  phAddress_Required_Header: "Hey, wir brauchen Deine Adresse, um Restaurants in Deiner Nähe anzeigen zu können",
  phAddress_Required_Alternative_Addresses: "Deine alternativen Lieferadressen",

  phChargeVoucherDialog_Change_Price_Title: "Aufladebetrag ändern",
  phChargeVoucherDialog_Change_Price_Info: "Soll der aktuelle Aufladebetrag von {currentAmount} durch {newAmount} ersetzt werden?",
  phChargeVoucherDialog_Change_Price_Confirm: "Ja, ersetzen ",
  phChargeVoucherDialog_Change_Price_Decline: "Nein, behalten",

  phRemoteOrder_DefineName_Title: "Neue Gruppenbestellung erstellen",
  phRemoteOrder_DefineUserName_Info: "Bitte gib Deinen Namen ein:",
  phRemoteOrder_DefineGroupName_Info: "Bitte gib einen Namen für Deine Gruppe ein:",
  phRemoteOrder_DefineUserName_Info_PlaceHolder: "Benutzername",
  phRemoteOrder_DefineGroupName_Info_PlaceHolder: "Gruppenname",

  phRemoteOrder_Input_Validate_Name_required: "Der Name darf nicht leer sein",
  phRemoteOrder_Input_Validate_Name_minlength: "Bitte gib mindestens 3 Buchstaben ein",
  phRemoteOrder_Input_Validate_Name_pattern: "Bitte keine Sonderzeichen verwenden",
  phRemoteOrder_Input_Validate_Name_forbiddenName: "Unzulässiger Name",

  phRemoteOrder_GroupName_display_label: "{username}'s Gruppe",

  phRemoteOrder_DefineTime_Title: "Bitte trage die gewünschten Zeiten für Deine Gruppenbestellung ein",
  phRemoteOrder_DefineTime_SeviceTime_Delivery_Info: "Die gewünschte Lieferzeit auswählen",
  phRemoteOrder_DefineTime_SeviceTime_Pickup_Info: "Die gewünschte Abholzeit auswählen",
  phRemoteOrder_DefineTime_Sevice_Pickup_Day_Label: "Abholtag :",
  phRemoteOrder_DefineTime_Sevice_Pickup_Time_Label: "Abholzeit :",
  phRemoteOrder_DefineTime_Sevice_Delivery_Day_Label: "Liefertag :",
  phRemoteOrder_DefineTime_Sevice_Delivery_Time_Label: "Lieferzeit :",

  phRemoteOrder_DefineTime_Order_Title: "Bestellfrist setzen",
  phRemoteOrder_DefineTime_Order_Info: "Wann sollen alle Gruppenmitglieder ihre Bestellungen abgegeben haben?",
  phRemoteOrder_DefineTime_Order_Notice: "Bitte stelle sicher, dass die Vorlaufzeit mindestens {minutes} Minuten beträgt.",
  phRemoteOrder_DefineTime_Order_Day: "Bestelltag :",
  phRemoteOrder_DefineTime_Order_Time: "Bestellzeit :",

  phRemoteOrder_Dialog_GroupMaxCountReached_Title: "Die maximale Anzahl ist erreicht",
  phRemoteOrder_Dialog_GroupMaxCountReached_Info: "Leider haben wir momentan die maximale Anzahl an Bestellgruppen erreicht. Du kannst gerne eine Einzelbestellung aufgeben oder es später noch einmal versuchen.",
  phRemoteOrder_Dialog_GroupFail_Title: "Erstellung der Bestellgruppe fehlgeschlagen",
  phRemoteOrder_Dialog_GroupFail_Info: "Leider kam es zu einem Fehler bei der Erstellung Deiner Bestellgruppe, bitte versuche es in einigen Minuten erneut.",
  phRemoteOrder_Dialog_Time_Conflict_Title: "Zeit anpassen",
  phRemoteOrder_Dialog_Time_Conflict_Info: "Für die ausgewählte Zeit kann leider keine Gruppenbestellung gemacht werden.Bitte ändere die Zeit und versuche es erneut.",
  phRemoteOrder_Dialog_Time_Conflict_TooSoon_Info: "Bitte beachte, dass die Vorlaufzeit mindestens {minutes} Minuten betragen muss. Wähle eine spätere Zeit.",
  phRemoteOrder_Dialog_Time_Conflict_button_label: "Zeit ändern",

  phRemoteOrder_GroupCreate_Confirm_Title: "{groupName} Gruppe wurde erfolgreich erstellt",
  phRemoteOrder_GroupCreate_Confirm_Nav_Info: "Über das Gruppensymbol in der Titelleiste kannst Du jederzeit den Status Deiner Gruppe einsehen.",
  phRemoteOrder_GroupCreate_Confirm_Pay_Info: "Bitte denke daran, dass Du als Gruppenersteller die Gesamtzahlung übernimmst.",
  phRemoteOrder_GroupCreate_Confirm_Invite_Info: "Lade Deine Freunde in diese Bestellgruppe ein, um eine gemeinsame Bestellung aufzugeben und euer Essen gemeinsam genießen zu können.",
  phRemoteOrder_GroupCreate_Confirm__Invite_Btn: "Jetzt einladen",

  phRemoteOrder_Without_Invite_Btn: "Weiter ohne einladen",
  phRemoteOrder_Invite_OrderBtn: "Jetzt Bestellen",

  phRemoteOrder_Share_Title: "Einladung zur Gruppenbestellung",
  phRemoteOrder_Share_SubText: "Teile den Gruppenlink mit Deinen Freunden, Kollegen oder Familienmitgliedern über WhatsApp, E-Mail und Co.",
  phRemoteOrder_share_Link: "Link teilen",

  phRemoteOrder_MaxMemberCount_Dialog_Title: "Keine weitere Einladung möglich",
  phRemoteOrder_MaxMemberCount_Dialog_SubText: "Die maximale Anzahl von Mitgliedern für diese Gruppe wurde erreicht.",

  phRemoteOrder_Confirm_Invite_Dialog_Title: "Möchtest Du keine Einladung senden?",
  phRemoteOrder_Confirm_Invite_Dialog_SubText: "Bist Du sicher, dass Du jetzt ohne Einladungen bestellen möchtest? Mit einer Gruppenbestellung könnt Ihr Euer Essen gemeinsam genießen.",
  phRemoteOrder_Confirm_Invite_Dialog_OrderBtn: "Bestellen",
  phRemoteOrder_Confirm_Invite_Dialog_InviteBtn: "Einladen",

  phRemoteOrder_Group_Servicepage_Title: "Bestellgruppe {groupname}",
  phRemoteOrder_Group_Servicepage_Creator: "von {creator}",
  phRemoteOrder_Group_Servicepage_BasketTitle: "Aktueller Gruppenwarenkorb",
  phRemoteOrder_Group_Servicepage_EmptyBasketContent: "Keine Artikel ausgewählt",
  phRemoteOrder_Group_Servicepage_BasketContent: "Artikel im Wert von",
  phRemoteOrder_Group_Servicepage_LeaveGroup: "Gruppe verlassen",
  phRemoteOrder_Group_Servicepage_Order: "Bestellen",
  phRemoteOrder_Group_Servicepage_Order_description: "Zum Menü navigieren",
  phRemoteOrder_Group_Servicepage_ViewGroup: "Meine Bestellgruppe",
  phRemoteOrder_Group_Servicepage_ViewGroup_description: "Gruppenübersicht anzeigen",
  phRemoteOrder_Group_Servicepage_Pay: "Bezahlen",
  phRemoteOrder_Group_Servicepage_Pay_description: "Bezahlen und Gruppenbestellung abschließen.",
  phRemoteOrder_Group_Servicepage_SendGroupOrder: "Gruppenbestellung absenden",

  phRemoteOrder_Group_Delivery_Address_To: "Gruppenlieferadresse: {groupaddress}",
  phRemoteOrder_Group_Delivery_Time: "Lieferzeit: {day} um {time}",
  phRemoteOrder_Group_Delivery_Time_Today: "Lieferzeit: heute um {time}",
  phRemoteOrder_Group_Delivery_From: "Von: {locationname}",
  phRemoteOrder_Group_Pickup_Address: "Abholung an dieser Adresse:",
  phRemoteOrder_Group_Pickup_Time: "Abholzeit: {day} um {time}",
  phRemoteOrder_Group_Pickup_Time_Today: "Abholzeit: heute um {time}",
  phRemoteOrder_Group_End_Time: "Bestellung: am {day} bis {time}",
  phRemoteOrder_Group_End_Time_Today: "Bestellung: heute bis {time}",
  phRemoteOrder_Group_Set_State_Ready: "Dein Bestellstatus:",
  phRemoteOrder_Group_Member_State: "Bestellstatus: ",
  phRemoteOrder_Group_Member_State_Ready: "Bereit",

  phRemoteOrder_Payment_Group: "Bestellgruppe",

  phRemoteOrder_Home_Button_Text: "Du bist Mitglied der Bestellgruppe",
  phRemoteOrder_Home_Button_Items: "{items_count} Artikel",
  phRemoteOrder_Home_Button_Info: "Bestellung abgeschlossen!",
  phRemoteOrder_Home_Button_Info_View_Details: " Details ansehen.",

  phRemoteOrder_Entry_Title: "Willkommen in der Bestellgruppe {groupName} von {userName}",
  phRemoteOrder_Entry_SubText: "Bitte gib Deinen Vornamen ein, damit wir Deine Bestellung richtig zuordnen können. ",
  phRemoteOrder_Entry_input: "Bitte gib Deinen Namen ein",
  phRemoteOrder_Entry_Join_Btn: "Beitreten",
  phRemoteOrder_Entry_Deny_Btn: "Ablehnen",

  phRemoteOrder_ContinueOrder_Label: "Artikel in den Gruppenwarenkorb gelegt",
  phRemoteOrder_ContinueOrder_State_Info: "Wenn du mit deiner Bestellung fertig bist, schließe die Bestellung ab und gehe zum Gruppenwarenkorb.",
  phRemoteOrder_ContinueOrder_Btn_Continue: "Weiter bestellen",
  phRemoteOrder_ContinueOrder_Btn_Cart: "Bestellung abschließen",

  phRemoteOrder_SendOrderDialog_Title: "Gruppenbestellung absenden?",
  phRemoteOrder_SendOrderDialog_Description: "Bist Du sicher, dass Du die Gruppenbestellung für alle Gruppenteilnehmer jetzt aufgeben möchtest?",
  phRemoteOrder_SendOrderDialog_Description_StateReady: "Bist du sicher, dass du die Gruppenbestellung jetzt für alle Teilnehmer aufgeben möchtest? Beachte, dass nicht alle Mitglieder ihren Status auf 'Ready' gesetzt haben.",
  phRemoteOrder_SendOrderDialog_AcceptBtn: "Ja, jetzt bestellen",
  phRemoteOrder_SendOrderDialog_DenyBtn: "Nein, zurück zur Gruppenansicht",

  phRemoteOrder_PayResult_Title: "Bestellung abgeschlossen ",
  phRemoteOrder_PayResult_Info: "Die Gruppenbestellung wurde erfolgreich abgeschlossen!",

  phRemoteOrder_ChangeOrder_Dialog_Title: "Möchtest du die Gruppe wirklich verlassen?",
  phRemoteOrder_ChangeOrder_Dialog_Content: "Um einen anderen Bestelltyp auszuwählen, musst du zuerst die Gruppe verlassen.",
  phRemoteOrder_ChangeOrder_Dialog_Button: "Gruppe verlassen",

  phRemoteOrder_Creator_Closed_Group_Dialog_Title: "Gruppe wurde beendet",
  phRemoteOrder_Creator_Closed_Group_Dialog_Content: "Der Gruppensteller hat die Gruppe verlassen. Die Gruppe wird daher beendet. Sie können gerne eine Einzelbestellung aufgeben oder eine neue Gruppe erstellen",

  phRemoteOrder_Member_Leave_Group_Dialog_Title: "Möchtest du die Gruppe wirklich verlassen?",
  phRemoteOrder_Member_Leave_Group_Dialog_Content: "Bitte beachte, dass ggf. alle deine Artikel im Gruppen-Warenkorb gelöscht werden, wenn du fortfährst.",
  phRemoteOrder_Member_Leave_Group_Dialog_Button: "Gruppe verlassen",

  phRemoteOrder_Creator_Leave_Group_Dialog_Title: "Möchtest du die Gruppe wirklich verlassen und beenden?",
  phRemoteOrder_Creator_Leave_Group_Dialog_Content: "Bitte beachte, dass du der Gruppenersteller bist. Wenn du die Gruppe verlässt, wird sie geschlossen.",
  phRemoteOrder_Creator_Leave_Group_Dialog_Button: "Gruppe verlassen",

  phRemoteOrder_PaymentStarted_NoOrderPossible_Title: "Zahlung läuft",
  phRemoteOrder_PaymentStarted_NoOrderPossible_Info: "Der Gruppenwarenkorb wird derzeit bezahlt. Es können keine weiteren Produkte hinzugefügt werden.",

  phRemoteOrder_MemberOrder_Detail_Owner_Label: "Deine Bestellübersicht",
  phRemoteOrder_MemberOrder_Detail_Guest_Label: "Bestellübersicht von {name}",
  phRemoteOrder_MemberOrder_Detail_Basket_Label: "Artikel im Wert von",
  phRemoteOrder_MemberOrder_Detail_Empty_Basket: "Keine Artikel im Gruppenwarenkorb",

  phRemoteOrder_Change_Service_Time_Title: "Wie die Zeit vergeht...",
  phRemoteOrder_Change_Service_Time_Info: "Deine ausgewählte Servicezeit {selectedServiceTime} ist leider abgelaufen. Bitte wähle eine neue Zeit aus.",
  phRemoteOrder_Change_Service_Time_Closed: "Leider können wir Deine Bestellung heute nicht mehr annehmen.",
  phRemoteOrder_Change_Service_Time_Cancel_Btn: "Abbrechen",

  phRemoteOrder_Reminder_Title: "Zeit, die Bestellung aufzugeben",
  phRemoteOrder_Reminder_Info: "Die Bestellfrist endet in {time} Minuten. Bitte stelle sicher, dass du alle gewünschten Artikel im Warenkorb hast.",

  phRemoteOrder_Group_Summary_Title: "Bestellgruppe {groupname}",
  phRemoteOrder_Group_Summary_ServiceTime_Delivery: "Lieferzeit: {day} um {time}",
  phRemoteOrder_Group_Summary_ServiceTime_Today_Delivery: "Lieferzeit: heute um {time}",
  phRemoteOrder_Group_Summary_ServiceTime_Pickup: "Abholzeit: {day} um {time}",
  phRemoteOrder_Group_Summary_ServiceTime_Today_Pickup: "Abholzeit: heute um {time}",
  phRemoteOrder_Group_Summary_Basket_Title: "Gruppenwarenkorb",
  phRemoteOrder_Group_Summary_Status: "Gruppenbestellung wurde erfolgreich abgeschlossen!",
  phRemoteOrder_Group_Summary_Delivery_Address_To: "Gruppenlieferadresse: {groupaddress}",
  phRemoteOrder_Group_Summary_Delivery_From: "Von {locationname}",
  phRemoteOrder_Group_Summary_Pickup_Address: "Abholung an dieser Adresse: ",
  phRemoteOrder_Group_Summary_Basket: "Artikel im Wert von",


  phTERMS_ACCESSIBILITY_TITLE: "Barrierefreiheitserklärung",
  phTERMS_ACCESSIBILITY_SECTION1_TITLE: "1. Geltende Anforderungen",
  phTERMS_ACCESSIBILITY_SECTION1_TEXT: "Die Anforderungen zur Barrierefreiheit für Dienstleistungen ergeben sich aus dem Barrierefreiheitsstärkungsgesetz (BFSG), insbesondere aus § 14 BFSG in Verbindung mit § 3 Abs. 1 BFSG, sowie der Verordnung zum Barrierefreiheitsstärkungsgesetz (BFSGV). Dienstleistungen sind barrierefrei, wenn sie für Menschen mit Behinderungen in der allgemein üblichen Weise, ohne besondere Erschwernis und grundsätzlich ohne fremde Hilfe auffindbar, zugänglich und nutzbar sind.",
  phTERMS_ACCESSIBILITY_SECTION2_TITLE: "2. Beschreibung der Dienstleistung",
  phTERMS_ACCESSIBILITY_SECTION2_TEXT1: "Die Hypersoft Trading GmbH mit Sitz in Hamburg entwickelt moderne Kassensysteme (POS Systeme) für die Gastronomiebranche. Das Unternehmen bietet integrierte Lösungen aus Software, Hardware und digitalen Services, die den gesamten Betriebs- und Gästeservice unterstützen.",
  phTERMS_ACCESSIBILITY_SECTION2_TEXT2: "Zum Leistungsportfolio gehören:",
  phTERMS_ACCESSIBILITY_SECTION2_LIST: ["Softwarelösungen und Kassensysteme: Skalierbare Systeme für Bestellungen, Zahlungen und Prozessopttimierung.", "Webshops, Self Order Terminals und Apps: Digitale Lösungen für Bestellungen und Zahlungen vor Ort oder mobil.", "Beratung, Vertrieb und Support: Persönliche Betreuung, Installation, Schulung und umfassende Dokumentation."],
  phTERMS_ACCESSIBILITY_SECTION3_TITLE: "3. Nutzung unserer digitalen Angebote",
  phTERMS_ACCESSIBILITY_SECTION3_TEXT: "Wir setzen uns dafür ein, dass unsere digitalen Dienste: Webshops, Self Order Terminals und Apps barrierefrei nutzbar sind. Dabei orientieren wir uns an den Vorgaben der Web Content Accessibility Guidelines (WCAG) 2.1, Konformitätsstufen A und AA.",
  phTERMS_ACCESSIBILITY_SECTION4_TITLE: "4. Merkmale der Barrierefreiheit",
  phTERMS_ACCESSIBILITY_SECTION4_TEXT1: "Die Anforderungen an die Barrierefreiheit laut BFSG finden sich in den folgenden drei Rechtsgrundlagen:",
  phTERMS_ACCESSIBILITY_SECTION4_LIST1: ["Barrierefreiheitsstärkungsgesetz (BFSG)", "Verordnung über die Barrierefreiheitsanforderungen für Produkte und Dienstleistungen nach dem Barrierefreiheitsstärkungsgesetz (BFSGV)", "Richtlinien für barrierefreie Webinhalte (WCAG)"],
  phTERMS_ACCESSIBILITY_SECTION4_TEXT2: "Nach diesen Rechtsgrundlagen muss unser Angebot vier Prinzipien der Barrierefreiheit erfüllen:",
  phTERMS_ACCESSIBILITY_SECTION4_LIST2: ["Wahrnehmbarkeit", "Bedienbarkeit", "Verständlichkeit", "Robustheit"],
  phTERMS_ACCESSIBILITY_SECTION4_SUBTITLE1: "Wahrnehmbarkeit",
  phTERMS_ACCESSIBILITY_SECTION4_SUBTITLE1_TEXT: "Alle informativen Inhalte, egal ob im Webshop, in den Apps oder an den Self Order Terminals, sind mit Alternativtexten und barrierearmen Darstellungen versehen. Bei der Gestaltung achten wir auf ausreichende Farbkontraste und die Möglichkeit, Bilder auszublenden. Schriftgrößen lassen sich im barrierefreien Modus erhöhen. Animationen können reduziert werden.",
  phTERMS_ACCESSIBILITY_SECTION4_SUBTITLE2: "Bedienbarkeit",
  phTERMS_ACCESSIBILITY_SECTION4_SUBTITLE2_TEXT: "Die Systeme, einschließlich Website, Apps und Self Order Terminals, sind vollständig per Tastatur, Screenreader oder Touch Bedienung nutzbar. Durch eine klare Struktur und eine verständliche Menüführung wird die Orientierung erleichtert. Zudem sind alle wesentlichen Funktionen, insbesondere der Bestell- und Bezahlprozess, auch im barrierefreien Modus verfügbar.",
  phTERMS_ACCESSIBILITY_SECTION4_SUBTITLE3: "Verständlichkeit",
  phTERMS_ACCESSIBILITY_SECTION4_SUBTITLE3_TEXT: "Wir bemühen uns, unsere Inhalte in einer möglichst klaren und verständlichen Sprache bereitzustellen. Eine vollständige Umsetzung nach dem Sprachniveau B2 des Gemeinsamen Europäischen Referenzrahmens für Sprachen (GER) ist derzeit noch in Arbeit. Wir arbeiten kontinuierlich daran, unsere Texte weiter zu vereinfachen und für alle Nutzer leichter zugänglich zu machen. Die Informationen können gelesen oder mit gängigen assistiven Programmen, wie Screenreadern, vorgelesen werden.",
  phTERMS_ACCESSIBILITY_SECTION4_SUBTITLE4: "Robustheit",
  phTERMS_ACCESSIBILITY_SECTION4_SUBTITLE4_TEXT: "Unsere digitalen Angebote (Webshops, Self Order Terminals und Apps) sind mit gängigen assistiven Technologien kompatibel. Die Umsetzung wurde durch eine Selbstbewertung geprüft.",
  phTERMS_ACCESSIBILITY_SECTION5_TITLE: "5. Stand der Barrierefreiheit",
  phTERMS_ACCESSIBILITY_SECTION5_TEXT1: "Unsere Webshops, Self Order Terminals und Smartphone Apps sind im barrierefreien Modus vollständig mit den Anforderungen des Barrierefreiheitsstärkungsgesetzes (BFSG) und den Web Content Accessibility Guidelines (WCAG) 2.1, Konformitätsstufen A und AA, vereinbar.",
  phTERMS_ACCESSIBILITY_SECTION5_TEXT2: "Im Standardmodus (ohne Aktivierung des barrierefreien Modus) sind die Anforderungen nicht in allen Bereichen vollständig umgesetzt. Folgende Barrieren können auftreten:",
  phTERMS_ACCESSIBILITY_SECTION5_LIST1: ["Schriftgrößen sind für Nutzer mit Sehbeeinträchtigungen möglicherweise zu klein.", "Farbkontraste entsprechen nicht immer den Mindestanforderungen.", "Animationen können für einige Nutzer störend sein.", "Bilder können Ladezeiten verlängern oder die Lesbarkeit beeinträchtigen."],
  phTERMS_ACCESSIBILITY_SECTION5_TEXT3: "Die volle Barrierefreiheit wird durch Aktivierung des barrierefreien Modus sichergestellt. Dieser umfasst insbesondere:",
  phTERMS_ACCESSIBILITY_SECTION5_LIST2: ["Erhöhung der Schriftgröße", "Anpassung der Farbkontraste", "Möglichkeit, Bilder auszublenden", "Reduzierung von Animationen"],
  phTERMS_ACCESSIBILITY_SECTION5_TEXT4: "Darüber hinaus stehen folgende Funktionen durchgehend zur Verfügung:",
  phTERMS_ACCESSIBILITY_SECTION5_LIST3: ["Vollständige Tastatur und Screenreader Bedienbarkeit", "Alternative Texte für Bilder", "Ein vollständig zugänglicher Bestellprozess einschließlich Bezahlvorgang, Widerrufsbelehrung und AGB"],
  phTERMS_ACCESSIBILITY_SECTION5_TEXT5: "Die Barrierefreiheit unseres Angebots wird mindestens einmal jährlich überprüft, und diese Erklärung wird entsprechend aktualisiert.",
  phTERMS_ACCESSIBILITY_SECTION6_TITLE: "6. NoCOO",
  phTERMS_ACCESSIBILITY_SECTION6_TEXT1: "Unsere digitalen Angebote werden durch das System NoCOO für digitale Rechnungen ergänzt. NoCOO bietet, ebenso wie unsere Webshops und Self Order Terminals einen barrierefreien Modus, der folgende Funktionen umfasst:",
  phTERMS_ACCESSIBILITY_SECTION6_LIST1: ["Erhöhung der Schriftgröße", "Anpassung der Farbkontraste", "Möglichkeit, Bilder auszublenden", "Reduzierung von Animationen"],
  phTERMS_ACCESSIBILITY_SECTION6_TEXT2: "Darüber hinaus stehen folgende Funktionen durchgehend zur Verfügung:",
  phTERMS_ACCESSIBILITY_SECTION6_LIST2: ["Vollständige Tastatur und Screenreader Bedienbarkeit", "Alternative Texte für Bilder"],
  phTERMS_ACCESSIBILITY_SECTION7_TITLE: "7. Feedback und Kontakt",
  phTERMS_ACCESSIBILITY_SECTION7_TEXT1: "Sollten Sie Barrieren feststellen oder Fragen zur Barrierefreiheit haben, freuen wir uns über Ihr Feedback. Bitte kontaktieren Sie uns unter:",
  phTERMS_ACCESSIBILITY_SECTION7_CONTACT: "Hypersoft Trading GmbH\nAmtsstraße 9\n22143 Hamburg\nTelefon: +49 (0) 40 66 905 - 100\nE-Mail: info@hypersoft.de\nWebsite: https://www.hypersoft.de",
  phTERMS_ACCESSIBILITY_SECTION8_TITLE: "8. Zuständige Marktüberwachungsbehörde",
  phTERMS_ACCESSIBILITY_SECTION8_CONTACT: "Freie und Hansestadt Hamburg\nBehörde für Arbeit, Gesundheit, Soziales, Familie und Integration\nAmt für Soziales – Abteilung Marktüberwachung BFSG\nHamburger Str. 47\n22083 Hamburg\nTelefon: +49 40 42863-0\nE-Mail: poststelle@soziales.hamburg.de\nWebsite: https://www.hamburg.de/soziales",
  phExpiredEvent_Title: "Preisänderung",
  phExpiredEvent_Description_Single: "Der Preis eines oder mehrerer Artikel in deinem Warenkorb hat sich geändert, da der ursprüngliche Sonderpreis nicht mehr verfügbar ist. Bitte überprüfe deine Bestellung.",
  phExpiredEvent_Description_GroupOrder: "Der Preis eines oder mehrerer Artikel im Gruppenwarenkorb hat sich geändert, da der ursprüngliche Sonderpreis nicht mehr verfügbar ist. Bitte überprüfe deine Bestellung.",

  phBasket_ServiceTime_Delivery: "Lieferzeit: {day} um {time}",
  phBasket_ServiceTime_Today_Delivery: "Lieferzeit: heute um {time}",
  phBasket_ServiceTime_ASAP_Today_Delivery: "heute um {time}",
  phBasket_ServiceTime_Pickup: "Abholzeit: {day} um {time}",
  phBasket_ServiceTime_Today_Pickup: "Abholzeit: heute um {time}",
  phBasket_ServiceTime_ASAP_Today_Pickup: "heute um {time}",

  phAGBConfirmationDialog_Title: "Allgemeine Geschäftsbedingungen",
  phAGBConfirmationDialog_Description: "Um fortzufahren, bitte einmalig die Allgemeinen Geschäftsbedingungen (AGB) und Datenschutzhinweise bestätigen.",
  phAGBConfirmationDialog_AcceptBtn: "Akzeptieren",
  phAGBConfirmationDialog_DeclineBtn: "Ablehnen",

  phRevokeOrder_FooterLink: "Vertrag widerrufen",
  phRevokeOrder_Tab1Title: "Vertrag widerrufen",
  phRevokeOrder_Tab2Title: "Bestätigung",
  phRevokeOrder_Tab1Subtitle: "Du kannst hier Deinen Vertrag widerrufen. Bitte mache die folgenden Angaben, wir benötigen sie, um Deinen Widerruf eindeutig Deiner Bestellung zuzuordnen.",
  phRevokeOrder_FieldName: "Name",
  phRevokeOrder_FieldEmail: "E-Mail-Adresse für die Eingangsbestätigung",
  phRevokeOrder_FieldOrderNumber: "Bestell- oder Auftragsnummer",
  phRevokeOrder_OrderNumberHint: "Du findest die Nummer in Deiner Bestellbestätigung per E-Mail.",
  phRevokeOrder_FieldArticles: "Betroffene Artikel",
  phRevokeOrder_FieldReason: "Grund des Widerrufs",
  phRevokeOrder_Optional: "(optional)",
  phRevokeOrder_Tab2Headline: "Dein Widerruf im Überblick",
  phRevokeOrder_Tab2Subtitle: "Bitte prüfe Deine Angaben. Mit Klick auf den Button unten wird Dein Widerruf rechtswirksam an uns übermittelt.",
  phRevokeOrder_ConfirmWarning: "Mit Klick auf 'Widerruf bestätigen' sendest Du Deine Erklärung verbindlich. Du erhältst unmittelbar eine Eingangsbestätigung per E-Mail.",
  phRevokeOrder_BtnConfirm: "Widerruf bestätigen",
  phRevokeOrder_PostConfirmHint: "Die Wirksamkeit Deines Widerrufs wird anschließend durch den Händler geprüft.",
  phRevokeOrder_ErrorRequired: "Dieses Feld ist erforderlich.",
  phRevokeOrder_ErrorEmailFormat: "Bitte gib eine gültige E-Mail-Adresse ein.",
  phRevokeOrder_LabelName: "Name",
  phRevokeOrder_LabelEmail: "E-Mail",
  phRevokeOrder_LabelOrderNumber: "Bestellnummer",
  phRevokeOrder_LabelArticles: "Artikel",
  phRevokeOrder_LabelReason: "Grund",
  phRevokeOrder_ResultSuccessHeadline1: "Vielen Dank.",
  phRevokeOrder_ResultSuccessHeadline2: "Dein Widerruf wurde erfolgreich übermittelt.",
  phRevokeOrder_ResultSuccessSubtext: "Eine Eingangsbestätigung wurde an die von Dir angegebene E-Mail-Adresse versendet.",
  phRevokeOrder_ResultErrorHeadline: "Leider konnte die Eingangsbestätigung nicht versendet werden.",
  phRevokeOrder_ResultErrorSubtext: "Dein Widerruf wurde daher nicht erfolgreich übermittelt. Bitte wende Dich direkt an den Anbieter. Die Kontaktdaten findest Du im Impressum.",

  phAccountPayment_SectionLabel: "Zahlung auf Rechnung",
  phAccountPayment_ButtonRequestActivation: "Anfrage senden",
  phAccountPayment_ButtonChangePaymentMethod: "Zahlart ändern",

  phWEBSHOP_ColorPreviewBanner: "Farbvorschau ({0}) – nicht der gespeicherte Stand",
  EOF: "EOF"
};
